import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SelectionEvent, GridDataResult, GridComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { BehaviorSubject, forkJoin, Subject } from 'rxjs';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { ColumnConfig, FieldValidation, ImportData } from 'src/app/features/common/models/column-config.model';
import { commonService } from 'src/app/services/common.service';
import { JobPlanSearchService } from '../../../service/job-plan-search.service';
import { ExportService } from 'src/app/services/export.service';
import { mwoService } from 'src/app/services/mwo.service';
import { JobPlanLabour, JobPlanPart } from 'src/app/interfaces/jobplan';
import { lastValueFrom } from 'rxjs';
import { PMService } from 'src/app/features/acd/service/pm.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { invalid } from 'moment';



@Component({
  selector: 'app-acd-jp-build',
  templateUrl: './acd-jp-build.component.html',
  styleUrl: './acd-jp-build.component.scss'
})
export class AcdJobPlanBuildComponent {
  @ViewChild('pmBuildGrid1') pmBuildGrid1?: GridComponent;
  @ViewChild('pmBuildGrid2') pmBuildGrid2?: GridComponent;
  iconPacks = EMDMICONS;
  crNo = 0;

  dropDownListLabour = ["Add Job Step", "Delete Job Step"];
  dropDownListParts = ["Add Part", "Delete Part"];
  bulkActionLabourValue: string = 'No change';
  LastUndoListLabour: any = [];
  lastbulkActionLabourValue = 'No change';
  labourActionApplied: boolean = false;
  partActionApplied: boolean = false;
  lastbulkActionPartValue = 'No change';
  bulkActionPartValue: string = 'No change';
  jpLabourMessage = '';
  jpPartsMessage = '';
  action: any = ['', 'Add', 'Delete', 'Change', 'No change'];
  normsList: any = [];
  icynList: any = [];
  mwoErrorTextList: any = [];
  undoList: any = [];
  undoListLabour: any = [];
  localadd: number = -1;
  @Input() set setCRNo(crNo: number) {
    if (crNo > 0 && this.crNo != crNo) {
      this.crNo = crNo;

      this.getLabour_PartsBuildData();
    }
  }

  @Input() set setCrDetails(crDetails: any) {
    let admin = sessionStorage.getItem('admin');
    let specialist = sessionStorage.getItem('specialist');
    if (crDetails) {
      this.otherUser = !((specialist == 'true') || (admin == 'true') || (crDetails?.isUserCanAccessRequest ?? false));
    } else {
      this.otherUser = true;
    }
  }

  otherUser: boolean = false
  showJobplanPopup: boolean = false
  expandedState = false;
  labourOGData: any[] = []; // isstaging = 0
  labourExportData: any = [];
  labourViewData: any[] = []; //user view data isstaging = 1
  deleteLabourViewData: any = []; //
  localDeleteLabourData: any = []; //

  partsOGData: any[] = []; // whole data with staging and non staging
  filterPartsViewData: any[] = []; //
  partsExportData: any = [];
  partsViewData: any[] = []; //user view data data isstaging = 
  deletePartsViewData: any = [];
  public selectedIds: Set<number> = new Set<number>();
  public labourSelectedIds: Set<number> = new Set<number>();
  public partsSelectedIds: Set<number> = new Set<number>();
  popupOpenField = "";
  selectedbranch = '';
  popUpOpenFieldChangeItemId = 0;
  popupShow = false;
  popupTccShow = false;
  showFileUploadPopup = false;
  fieldValidationInput!: FieldValidation[];
  applyBtnPressed: boolean = false;
  showAllParts: boolean = false;
  fieldValidationInput_Labour: FieldValidation[] = [
    {
      field: 'emdmKey',
      title: 'EMDM Key',
      validations: []
    },
    {
      field: 'equipTagNumber',
      title: 'Equip Tag Number',
      validations: []
    },
    {
      field: 'mwoNumber',
      title: 'MWO Number',
      validations: []
    },
    {
      field: 'mwoProblemDescription',
      title: 'Mwo Problem Description',
      validations: []
    },
    {
      field: 'jobPlanNumber',
      title: 'Job Plan Number',
      validations: []
    },
    {
      field: 'jobPlanDescription',
      title: 'Job Plan Description',
      validations: []
    },
    {
      field: 'performanceStandard',
      title: 'Performance Standard',
      validations: []
    },
    {
      field: 'branchPlant',
      title: 'Branch',
      validations: []
    },
    {
      field: 'craft',
      title: 'Craft',
      validations: []
    },
    {
      field: 'opsSeq',
      title: 'Operation Sequence',
      validations: []
    },
    {
      field: 'description',
      title: 'Description',
      validations: []
    },
    {
      field: 'duration',
      title: 'Duration',
      validations: []
    },
    {
      field: 'crewSize',
      title: 'Crew Size',
      validations: []
    },
    {
      field: 'icyn',
      title: 'IC Y_N',
      validations: []
    },
    {
      field: 'percentageOverlap',
      title: 'Percentage Overlap',
      validations: []
    },
    {
      field: 'task',
      title: 'Task',
      validations: []
    },
    {
      field: 'messageNumber',
      title: 'Message Number',
      validations: []
    },
    {
      field: 'equipmentNumber',
      title: 'Equipment Number',
      validations: []
    },
    {
      field: 'fileName',
      title: 'File Name',
      validations: []
    },
    {
      field: 'url',
      title: 'URL',
      validations: []
    },
    {
      field: 'fileDescription',
      title: 'File Description',
      validations: []
    },
    {
      field: 'textAttachments',
      title: 'Text Attachment',
      validations: []
    },
    {
      field: 'jbcd',
      title: 'JBCD',
      validations: []
    },
    {
      field: 'jobPackNo',
      title: 'Job Pack No',
      validations: []
    },
  ];
  fieldValidationInput_Parts: FieldValidation[] = [
    {
      field: 'emdmKey',
      title: 'EMDM Key',
      validations: []
    },
    {
      field: 'equipTagNumber',
      title: 'Equip Tag Number',
      validations: []
    },
    {
      field: 'mwoNumber',
      title: 'MWO Number',
      validations: []
    },
    {
      field: 'mwoProblemDescription',
      title: 'Mwo Problem Description',
      validations: []
    },
    {
      field: 'jobPlanNumber',
      title: 'Job Plan Number',
      validations: []
    },
    {
      field: 'branchPlant',
      title: 'Branch',
      validations: []
    },
    {
      field: 'item',
      title: 'Item Number',
      validations: []
    },
    {
      field: 'quantity',
      title: 'Quantity',
      validations: []
    },
    {
      field: 'compBranchPlant',
      title: 'Comp Branch',
      validations: []
    },
    {
      field: 'operationSequence',
      title: 'Operation Sequence',
      validations: []
    }
  ];
  popupTitle = "";
  popupHeight = 440;
  tccpopupHeight = 440;
  popupBtnText = ""
  popupWidth = 600;
  tccpopupWidth = 600;
  searchPlaceHolder = "Search";
  jobPlanData = [
    {
      JobPlanNumber: "NEW 2 from (NEW)",
      Branch: "140062111A"
    },
    {
      JobPlanNumber: "NEW 1 from (NEW)",
      Branch: "140062111A"
    },
    {
      JobPlanNumber: "NEW 1 from FS_OCT_REMPFILT1S1102_00 (NEW)",
      Branch: "140062011A"
    },
    {
      JobPlanNumber: "NEW 1 from JPN_TEST_01 (NEW)",
      Branch: "140062011A"
    },
    {
      JobPlanNumber: "NEW 1 from VA_TAI_P139938DIS_11 (NEW)",
      Branch: "140062011A"
    }
  ];
  craftData = [];
  tccData = [];
  serviceTypeList: any[] = [];
  serviceTypeSelectColumn: any[] = [];
  jobplanSelectColumn: ColumnConfig[] = [
    { field: 'JobPlanNumber', title: 'Job Plan Number', width: 300, isSearchProperty: true },
    { field: 'Branch', title: 'Branch', width: 200, isSearchProperty: true },
  ]

  craftSelectColumn: ColumnConfig[] = [
    { field: 'Code', title: 'Code', width: 150, isSearchProperty: true },
    { field: 'Description', title: 'Description', width: 200, isSearchProperty: true },
  ]

  tccColumn: ColumnConfig[] = [
    { field: 'TaskId', title: 'Task Id', width: 150, isSearchProperty: true },
    { field: 'Task', title: 'Task', width: 200, isSearchProperty: true },
    { field: 'Consequence', title: 'Consequence', width: 200, isSearchProperty: false },
  ]

  constructor(private commonService: commonService, private mwoService: mwoService, private jobPlanService: JobPlanSearchService, private exportService: ExportService,
    private pmService: PMService,
  ) {
    this.getMwoDropdownData('Norms');
    this.getMwoDropdownData('Ic_Y_N_Urcd');
  }

  setHeaderMessage() {
    //labour message
    let savedTotal = 0; //not added to cr
    let addedTotal = 0; // added to cr
    this.labourViewData.forEach((x: any) => {
      if (x.isAddedToCR) {
        addedTotal++;
      } else {
        savedTotal++;
      }
    })
    if (addedTotal == 0 && savedTotal == 0) {
      this.jpLabourMessage = '';
    } else
      if (addedTotal == 0) {
        this.jpLabourMessage = savedTotal + ' records saved';
      } else if (savedTotal == 0) {
        this.jpLabourMessage = addedTotal + ' records added';
      }
      else {
        this.jpLabourMessage = 'total of ' + (addedTotal + savedTotal) + ' records : ' + savedTotal + ' saved, ' + addedTotal + ' added';
      }
    //parts message set
    addedTotal = 0;
    savedTotal = 0;
    this.filterPartsViewData.forEach((x: any) => {
      if (x.isAddedToCR) {
        addedTotal++;
      } else {
        savedTotal++;
      }
    })
    if (addedTotal == 0 && savedTotal == 0) {
      this.jpPartsMessage = '';
    } else
      if (addedTotal == 0) {
        this.jpPartsMessage = savedTotal + ' records saved';
      } else if (savedTotal == 0) {
        this.jpPartsMessage = addedTotal + ' records added';
      }
      else {
        this.jpPartsMessage = savedTotal + ' record saved, ' + addedTotal + ' records added';
        //this.jpPartsMessage = 'total of ' + (addedTotal + savedTotal) + ' records : ' + savedTotal + ' record saved, ' + addedTotal + ' records added';
      }
  }

  getLabour_PartsBuildData() {
    let requestList = [
      this.jobPlanService.getLabourData(this.crNo),
      this.jobPlanService.getPartsData(this.crNo)
    ];

    forkJoin(requestList).subscribe({
      next: (response: any[]) => {
        if (requestList.length == response.length) {

          if (response[0]) {

            this.labourOGData = JSON.parse(JSON.stringify(response[0].filter((x: any) => !x.isStaging || x.acdAction == 'Add')));
            this.labourViewData = JSON.parse(JSON.stringify(response[0].filter((x: any) => x.isStaging)));

            let pre_eqno_mwo_jno = ''
            let pre_jp_no = '';
            let pre_jp_no_color = '';

            this.labourViewData = this.labourViewData?.map((data: any, index: number) => {
              // const maxChangeitemIdLabour = ++this.maxChangeitemIdLabourv
              data.equipTagNumber = data.equipTagNumber?.split(',').sort().join(',');
              data.mwoNumber = data.mwoNumber?.split(',').sort().join(',');
              data.mwoProblemDescription = data.mwoProblemDescription?.split(',').sort().join(',');
              data.acdAction = this.action[data.acdAction];
              // data.be_changeItemId = data.changeItemId;
              // data.changeitemId = ++this.maxChangeitemIdLabour;
              data.errorList = [];
              // data.changeitemId = data.rowNumber ? data.rowNumber:  ++this.maxChangeitemIdLabour;
              data.operationId = data.operationId || 4;
              data.craft = data.craft.trim();
              if (data.acdAction === 'No change') {
                data.fieldChangedList = data.modifiedFields?.split(';');
                data.fieldChangedListTrack = [];
              } else {
                data.fieldChangedList = data.modifiedFields?.split(';');
                data.fieldChangedListTrack = [];
              }

              //color
              if (pre_jp_no === data.jobPlanNumber) {
                data.color = pre_jp_no_color;
              } else {
                pre_jp_no = data.jobPlanNumber;
                if (pre_jp_no_color == '')
                  pre_jp_no_color = 'grayRow'
                else
                  pre_jp_no_color = '';

                data.color = String(pre_jp_no_color);
              }

              // viewOnly
              if (pre_eqno_mwo_jno == (data.equipTagNumber + data.mwoNumber + data.jobPlanNumber)) {
                data.view_equipTagNumber = '';
                data.view_mwoNumber = '';
                data.view_jobPlanNumber = '';
                data.view_mwoProblemDescription = '';
              } else {
                data.view_equipTagNumber = data.equipTagNumber;
                data.view_mwoNumber = data.mwoNumber;
                data.view_jobPlanNumber = data.jobPlanNumber;
                data.view_mwoProblemDescription = data.mwoProblemDescription;
                data.export_mwoNumber = data.mwoNumber,
                  data.export_equipTagNumber = data.equipTagNumber,
                  data.export_mwoProblemDescription = data.mwoProblemDescription,
                  pre_eqno_mwo_jno = (data.equipTagNumber + data.mwoNumber + data.jobPlanNumber)
                data.equipTagNumberList = data.equipTagNumber?.split(",");
                // x.tagNumber_View = x.tagNumberList?.splice(0, 5).join(",<br>") ?? "";
                data.view_equipTagNumber = data.equipTagNumber?.split(",")?.splice(0, 5).join(",<br>") ?? "";
                if (data.equipTagNumberList?.length > 5) {
                  data.view_equipTagNumber += "...";
                }
                data.mwoList = data.mwoNumber?.split(",");
                data.view_mwoNumber = data.mwoNumber?.split(",")?.splice(0, 5).join(",<br>") ?? "";
                if (data.mwoList?.length > 5) {
                  data.view_mwoNumber += "...";
                }

                data.mwoProbDescList = data.mwoProblemDescription?.split(",");
                data.view_mwoProblemDescription = data.mwoProblemDescription?.split(",")?.splice(0, 5).join(",<br>") ?? "";
                if (data.mwoProbDescList?.length > 5) {
                  data.view_mwoProblemDescription += "...";
                }
              }

              data.lastJobPLanNumber = data.jobPlanNumber
              return data;
            })

            this.labourExportData = JSON.parse(JSON.stringify(this.labourViewData));
            this.setHeaderMessage();
          }

          if (response[1]) {

            this.partsOGData = JSON.parse(JSON.stringify(response[1].filter((x: any) => !x.isStaging || x.acdAction == 'Add')));
            // this.partsExportData = JSON.parse(JSON.stringify(response[1].filter((x: any) => x.isStaging)));
            this.partsViewData = JSON.parse(JSON.stringify(response[1].filter((x: any) => x.isStaging)));

            let pre_eqno_mwo_jno = ''
            this.partsViewData = this.partsViewData?.map((data: any, index: number) => {
              data.equipTagNumber = data.equipTagNumber?.split(',').sort().join(',');
              data.mwoNumber = data.mwoNumber?.split(',').sort().join(',');
              data.mwoProblemDescription = data.mwoProblemDescription?.split(',').sort().join(',');
              data.acdAction = this.action[data.acdAction];
              data.errorList = [];
              data.operationId = data.operationId || 4;

              if (data.acdAction === 'No change') {
                if (data.modifiedFields) {
                  data.fieldChangedList = data.modifiedFields?.split(';');
                }
                data.fieldChangedListTrack = [];
              } else {
                if (data.modifiedFields) {
                  data.fieldChangedList = data.modifiedFields?.split(';');
                }
                data.fieldChangedListTrack = [];
              }


              // viewOnly
              if (pre_eqno_mwo_jno == (data.equipTagNumber + data.mwoNumber + data.jobPlanNumber)) {
                data.view_equipTagNumber = '';
                data.view_mwoNumber = '';
                data.view_jobPlanNumber = '';
                data.view_mwoProblemDescription = '';
              } else {
                data.view_equipTagNumber = data.equipTagNumber;
                data.view_mwoNumber = data.mwoNumber;
                data.view_jobPlanNumber = data.jobPlanNumber;
                data.view_mwoProblemDescription = data.mwoProblemDescription;
                data.export_mwoNumber = data.mwoNumber,
                  data.export_equipTagNumber = data.equipTagNumber,
                  data.export_mwoProblemDescription = data.mwoProblemDescription,
                  pre_eqno_mwo_jno = (data.equipTagNumber + data.mwoNumber + data.jobPlanNumber)
                data.equipTagNumberList = data.equipTagNumber?.split(",");
                data.view_equipTagNumber = data.equipTagNumber?.split(",")?.splice(0, 5).join(",<br>") ?? "";
                if (data.equipTagNumberList?.length > 5) {
                  data.view_equipTagNumber += "...";
                }
                data.mwoList = data.mwoNumber?.split(",");
                data.view_mwoNumber = data.mwoNumber?.split(",")?.splice(0, 5).join(",<br>") ?? "";
                if (data.mwoList?.length > 5) {
                  data.view_mwoNumber += "...";
                }
                data.mwoProbDescList = data.mwoProblemDescription?.split(",");
                data.view_mwoProblemDescription = data.mwoProblemDescription?.split(",")?.splice(0, 5).join(",<br>") ?? "";
                if (data.mwoProbDescList?.length > 5) {
                  data.view_mwoProblemDescription += "...";
                }
              }
              return data;
            })
            // let jobplanList = this.partsViewData.map((x: any) => x.jobPlanNumber);
            // let uniquejobplannumber = Array.from(new Set(jobplanList));
            // uniquejobplannumber.forEach((x:any)=>{
            //   let count =0;
            //   this.partsViewData.forEach((y:any)=>{ if(y.jobPlanNumber == x && y.acdAction.toLocaleLowerCase() == 'add') count++});        

            //   if(count > 1){
            //     console.log(count, "jp",x);
            //   }});
            // console.log(uniquejobplannumber);
            this.partsExportData = JSON.parse(JSON.stringify(this.partsViewData));
            //this.SortPartData();   commenting as the sorting is happening directly from database
            this.getPartsViewData();
            this.setHeaderMessage();
          }
        }
      }
    });
    this.setHeaderMessage();
  }

  getClassByColor(context: RowClassArgs) {
    if (context.dataItem.color == "grayRow") {
      return { odd: true };
    } else {
      return { even: true };
    }
  }

  findJobplanPopup() {
    this.showJobplanPopup = true;
    let jobplanList = this.labourViewData.map((x: any) => x.jobPlanNumber);
    let uniquejobplannumber = Array.from(new Set(jobplanList));
    if (uniquejobplannumber.length == 1) {
      this.changePlan = {
        oldJobPlanNumber: uniquejobplannumber[0],
        newJobPlanNumber: '',
      }
    }
  }
  changePlan = {
    oldJobPlanNumber: '',
    newJobPlanNumber: '',
  }

  customFormat(val: number): string {
    const decimalPlaces = val % 1 === 0 ? 0 : val.toString().split('.')[1]?.length || 0;
    let format = `#.${'#'.repeat(decimalPlaces)}`;
    // console.log(format)
    return format;
  }

  // customFormat(val : number) :  string{
  //   if (val % 1 === 0) {
  //     return '#';
  //   } else if( val.toString().split('.')[1].length == 1){
  //     return '#.#';
  //   }else if( val.toString().split('.')[1].length == 2){
  //     return '#.##';
  //   }else{
  //     return '#.###';
  //   }
  // }
  findJobPlan() {
    this.applyBtnPressed = true;
    if (this.changePlan.newJobPlanNumber == '' || this.changePlan.oldJobPlanNumber == '') {
    } else {
      if (!confirm('Are you sure to replace job plan number?')) {
        return;
      }

      let body = {
        changeRequestId: this.crNo,
        oldJobPlanNumber: this.changePlan.oldJobPlanNumber,
        newJobPlanNumber: this.changePlan.newJobPlanNumber,
      }

      let jobplanList = this.labourViewData.map((x: any) => x.jobPlanNumber);
      let uniquejobplannumber = Array.from(new Set(jobplanList));

      if (!uniquejobplannumber?.includes(body.oldJobPlanNumber)) {
        let localmsg = "No changes performed while attempting to replace job plan number '" + body.newJobPlanNumber + "' with '" + body.oldJobPlanNumber;
        this.commonService.showNotificationMessage(localmsg, 'warning', 'center');
        return;
      }

      let changeCount = 0;

      this.labourViewData.forEach((obj, index) => {
        if (obj.jobPlanNumber === body.oldJobPlanNumber && this.labourViewData[index].acdAction == 'Add') {
          this.labourViewData[index].jobPlanNumber = body.newJobPlanNumber;
          this.labourViewData[index].operationId = 3;
          changeCount++;
        }
      });

      this.partsViewData.forEach((obj, index) => {
        if (obj.jobPlanNumber === body.oldJobPlanNumber && this.partsViewData[index].acdAction == 'Add') {
          this.partsViewData[index].jobPlanNumber = body.newJobPlanNumber;
          this.partsViewData[index].operationId = 3;
          changeCount++;
        }
      });

      let successMessage = "Job plan number '" + body.oldJobPlanNumber + "' replaced with '" + body.newJobPlanNumber + "'  ( " + changeCount + "rows changed)."
      this.commonService.showNotificationMessage(successMessage, 'success', 'center');
      this.labourSelectedIds.clear()
      this.partsSelectedIds.clear();
      this.showJobplanPopup = false;
      this.undoList.push(body);
    }
  }

  undoJobPlan() {
    this.undoList.forEach((body: any) => {
      this.labourViewData.forEach((obj, index) => {
        if (obj.jobPlanNumber === body.newJobPlanNumber && obj.acdAction == 'Add') {
          this.labourViewData[index].jobPlanNumber = body.oldJobPlanNumber;
        }
      });

      this.partsViewData.forEach((obj, index) => {
        if (obj.jobPlanNumber === body.newJobPlanNumber && obj.acdAction == 'Add') {
          this.partsViewData[index].jobPlanNumber = body.oldJobPlanNumber;
        }
      });
    });
    this.undoList = [];
    this.commonService.showNotificationMessage('ACD Action changes in Labour undone.', 'success', 'center');
  }

  closePopup() {
    this.showJobplanPopup = false;
  }

  closeFileUploadPopup() {
    this.showFileUploadPopup = false;
  }

  public expandCollapseContent(): void {
    this.expandedState = !this.expandedState;
  }

  OnSelectionChangeEventGrid(event: SelectionEvent, gridName: string) {

    if (gridName == 'labour') {
      this.labourSelectedIds = this.commonService.JopPlanSelectionGrid(this.labourSelectedIds, event, 'id', 'changeItemId');
      this.getPartsViewData(true);      

    } else if (gridName == 'parts') {
      this.partsSelectedIds = this.commonService.JopPlanSelectionGrid(this.partsSelectedIds, event, 'id', 'changeItemId');
    }
  }

  @Output() stepNavigateTo = new EventEmitter<string>();

  backBTNClicked() {
    this.stepNavigateTo.emit('Search');
  }

  onValueChange(dataItem: any, field: string, event: any) {
    const lastJobPLanNumber = dataItem.lastJobPLanNumber;
    dataItem.fieldChangedList ??= [];
    dataItem.fieldChangedListTrack ??= [];
    // console.log(event)
    let vData = this.labourViewData.find((x: any) => dataItem.changeItemId == x.changeItemId);
    if (dataItem.acdAction != 'Add') {
      let ogData = this.labourOGData.find((x: any) => (vData.changeItemId == x.changeItemId)) as { [key: string]: any };
      if (ogData && ogData[field] !== event) {
        if (dataItem.fieldChangedList.find((x: string) => x == field) == undefined) {
          dataItem.fieldChangedList.push(field);
          dataItem.operationId = 3;
        }

      }
      else {
        let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }
      dataItem.acdAction = dataItem.fieldChangedList.length == 0 ? 'No change' : 'Change';
      dataItem.acdActionLabel = dataItem.fieldChangedList.length == 0 ? 'No change' : 'Change';
      dataItem.operationId = dataItem.fieldChangedList.length == 0 ? 4 : 3;
      dataItem.acdId = this.commonService.setACDID(dataItem.acdAction);


    }
    // track current changes for operationId

    let ogData = this.labourExportData.find((x: any) => (x.isStaging && vData.changeItemId == x.changeItemId)) as { [key: string]: any };
    if (ogData && ogData[field] !== event) {
      if (dataItem.fieldChangedListTrack.find((x: string) => x == field) == undefined) {
        dataItem.fieldChangedListTrack.push(field);
        dataItem.operationId = 3;
      }

    }
    else {
      let index = dataItem.fieldChangedListTrack.findIndex((x: string) => x == field);
      if (index > -1) {
        dataItem.fieldChangedListTrack.splice(index, 1);
      }
    }

    let viewIndex = this.labourViewData.findIndex((x: any) => dataItem.changeItemId == x.changeItemId);
    if (field == 'crewSize') {
      if (event > 10) {
        this.commonService.showNotificationMessage('Crew Size is greater than 10, please confirm', 'warning', 'center');
        this.labourViewData[viewIndex]?.errorList?.push('crewSize');
      }
      else {
        let index = this.labourViewData[viewIndex].errorList.findIndex((x: string) => x == field);
        if (index > -1) {
          this.labourViewData[viewIndex].errorList.splice(index, 1);
        }
      }
    }

    if (field == 'jobPlanNumber') {
      let labourDataItem = this.labourExportData.filter((x: any) => x.changeItemId == dataItem.changeItemId);
      let filterData = this.partsExportData.filter((x: any) => x.jobPlanNumber == labourDataItem[0].jobPlanNumber && x.operationSequence == dataItem.opsSeq);
      filterData.forEach((x: any) => {
        let index = this.partsViewData.findIndex((y: any) => y.changeItemId == x.changeItemId);
        this.partsViewData[index].jobPlanNumber = event;
        this.partsViewData[index].operationId = 3;
        this.partsViewData[index].fieldChangedListTrack.push('jobPlanNumber');
      });
      dataItem.lastJobPLanNumber = event;

    }
    this.getPartsViewData();
  }


  onPartValueChange(dataItem: any, field: string, event: any) {
    dataItem.fieldChangedList ??= [];
    dataItem.fieldChangedListTrack ??= [];

    let vData = this.partsViewData.find((x: any) => dataItem.changeItemId == x.changeItemId);
    if (dataItem.acdAction != 'Add') {
      let ogData = this.partsOGData.find((x: any) => vData.changeItemId == x.changeItemId) as { [key: string]: any };

      if (ogData && ogData[field] !== event) {

        if (dataItem.fieldChangedList.find((x: string) => x == field) == undefined) {
          dataItem.fieldChangedList.push(field);
          dataItem.operationId = 3;
        }

      }
      else {
        let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }

      dataItem.acdAction = dataItem.fieldChangedList.length == 0 ? 'No change' : 'Change';
      dataItem.operationId = dataItem.fieldChangedList.length == 0 ? 4 : 3;
      dataItem.acdId = this.commonService.setACDID(dataItem.acdAction);
    }
    // change current changes for operationId
    let ogData = this.partsExportData.find((x: any) => vData.changeItemId == x.changeItemId) as { [key: string]: any };

    if (ogData && ogData[field] !== event) {

      if (dataItem.fieldChangedListTrack.find((x: string) => x == field) == undefined) {
        dataItem.fieldChangedListTrack.push(field);
        dataItem.operationId = 3;
      }

    }
    else {
      let index = dataItem.fieldChangedListTrack.findIndex((x: string) => x == field);
      if (index > -1) {
        dataItem.fieldChangedListTrack.splice(index, 1);
      }
    }

  }

  skip = 0;
  pageSize = 5;
  tccpageSize = 5;
  searchText: string = "";
  popupDataList!: GridDataResult;

  popupGridColumn: ColumnConfig[] = [
    { field: 'type', title: 'Service Type', width: 120, isSearchProperty: true },
    { field: 'description', title: 'Description', width: 280, isSearchProperty: true },
  ];

  getJobPlanPopupData() {
    this.jobPlanService.getJobPlanData(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getMwoDropdownData(tableName: string) {
    this.mwoService.getMwoDropdownData(tableName).subscribe({
      next: (response: any) => {
        if (response) {
          if (tableName == 'Norms') {
            this.normsList = response.sort();

          } else
            if (tableName == 'Ic_Y_N_Urcd') {
              this.icynList = response.sort();

            }

        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }



  leadCraftPopupData() {
    this.mwoService.getLeadCraftCode(this.skip, this.pageSize, this.searchText, this.crNo).subscribe({
      next: (response: any) => {
        if (response) {
          this.popupDataList = {
            data: response.item1,
            total: response.item2
          };
          this.popupShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }
  getTccidPopupData() {
    this.jobPlanService.GetTaskDetails(this.skip, this.tccpageSize, this.searchText).subscribe({
      next: (response: any) => {
        if (response) {         
          this.popupDataList = {
            data: [{ task: "Blank", taskID: "", consequence: "" }, ...response.item1],
            total: response.item2
          };
          this.popupTccShow = true;
        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupTccShow = true;
      }
    });
  }
  GetItemSearch() {
    this.jobPlanService.GetItemSearch(this.skip, this.pageSize, this.selectedbranch, this.searchText).subscribe({
      next: (response: any) => {
        if (response) {
            this.popupDataList = {
              data: response.item1,
              total: response.item2
          };
          this.popupShow = true;
          }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  async ImportJobPlanBuildLabour(data: any) {
    let source$ = this.jobPlanService.ImportJobPlanBuildLabour(this.crNo, data);
    const lastValue = await lastValueFrom(source$);
    return lastValue;
  }

  async ImportJobPlanBuildParts(data: any) {
    let source$ = this.jobPlanService.ImportJobPlanBuildParts(this.crNo, data);
    const lastValue = await lastValueFrom(source$);
    return lastValue;
  }

  async ValidateAndSaveToCr(data: any) {
    let source$ = this.jobPlanService.ValidateAndSaveToCr(data);
    const lastValue = await lastValueFrom(source$);
    return lastValue;
  }
  deleteCount = {
    deleteLabour: 0,
    deleteParts: 0
  };

  ClearJobPlanLabour(isSelectedAll: boolean = false, selectedItems: string = '', selectedJobplanNumbers: string = '') {
    let validchangeItemIds = [...this.labourSelectedIds].filter(id => id > 0);
    let invalidchangeItemIds = [...this.labourSelectedIds].filter(id => id < 0);
    if (invalidchangeItemIds.length > 0) {
      invalidchangeItemIds.forEach((id: any) => {
        let index = this.labourViewData.find(data => data.id == id); // find jobplan number 
        if (index > -1) {
          let ciid = this.labourViewData.findIndex((data: any) => {
            data.id > 0 && data.jobPlanNumber == this.labourViewData[index].jobPlanNumber // find one chaNGEITEMID WITH SAME jobplan
          });
          validchangeItemIds.push(this.labourViewData[ciid].changeItemId);
        }
      });
    }
    // if (validchangeItemIds.length > 0 || isSelectedAll) {
    let jobplanlist = this.labourViewData.filter((x: any) => validchangeItemIds.includes(x.changeItemId)).map((x: any) => x.jobPlanNumber);
    let changeItemListLabour = this.labourViewData.filter((x: any) => jobplanlist.includes(x.jobPlanNumber)).map((x: any) => x.changeItemId);
    let changeItemListParts = this.partsViewData.filter((x: any) => jobplanlist.includes(x.jobPlanNumber)).map((x: any) => x.changeItemId);
    let par = {
      changeRequestId: this.crNo,
      isSelectedAll: isSelectedAll,
      selectedItems: validchangeItemIds,
      selectedJobplanNumberLabour: changeItemListLabour.join(','),
      selectedJobplanNumberParts: changeItemListParts.join(',')
    };
    this.jobPlanService.ClearJobPlanLabour(par).subscribe({
      next: (response: any) => {
        if (response) {
          if (response.status.startsWith('0 Labour')) {
            this.commonService.showNotificationMessage(response, 'success', 'center');
            this.labourViewData = [...this.labourViewData]
          }
          else {
            let invalidDataCount = [...this.labourSelectedIds].filter(id => id < 0);
            if (par.isSelectedAll) {
              let clearAllResponse = `${this.labourViewData?.length} Labour & ${this.partsViewData?.length} Part record(s) cleared from CR successfully`
              this.labourViewData = [];
              this.partsViewData = [];
              this.filterPartsViewData = [];
              this.jpLabourMessage = '';
              this.jpPartsMessage = '';
              this.commonService.showNotificationMessage(clearAllResponse, 'success', 'center');
            }
            else {
              [...this.labourSelectedIds].map(id => this.removeDataItem(id));
              let clearAllResponse = `${(response.deleteLabourCount + this.deleteCount.deleteLabour)} Labour & ${(response.deletePartCount + this.deleteCount.deleteParts)} Part record(s) cleared from CR successfully`;
              this.commonService.showNotificationMessage(clearAllResponse, 'success', 'center');
            }
            // this.getLabour_PartsBuildData();
          }

          this.labourSelectedIds.clear()
          this.partsSelectedIds.clear()

        }
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
    // } 
    // else {
    //   let invalidchangeItemIds = [...this.labourSelectedIds].filter(id => id < 0);
    //   invalidchangeItemIds.forEach((id: any) => {
    //     this.removeLabourItem(id, []);

    //   });
    //   this.labourSelectedIds.clear();
    //   this.commonService.showNotificationMessage(`${invalidchangeItemIds.length} labours and 0 parts deleted successfully`, 'success', 'center');
    // }
    this.setHeaderMessage()
    this.labourActionApplied = false;
    this.getPartsViewData();
  }

  ClearJobPlanLabourNew(isSelectedAll: boolean = false, selectedItems: string = '', selectedJobplanNumbers: string = '') {
    if (isSelectedAll) {
      let payload = {
        isSelectedAll: true,
        changeRequestId: this.crNo
      }
      this.jobPlanService.ClearJobPlanLabour(payload).subscribe({
        next: (response: any) => {
          if (response) {
            let clearAllResponse = `${this.labourViewData?.length} Labour & ${this.partsViewData?.length} Part record(s) cleared from CR successfully`
            this.labourViewData = [];
            this.partsViewData = [];
            this.filterPartsViewData = [];
            this.jpLabourMessage = '';
            this.jpPartsMessage = '';
            this.commonService.showNotificationMessage(clearAllResponse, 'success', 'center');
            this.getPartsViewData();
          }
        }
      });
    } else {
      let jobplanList = this.labourViewData.filter((x: any) => [...this.labourSelectedIds].includes(x.changeItemId)).map((x: any) => x.jobPlanNumber);
      let changeItemListLabour = this.labourViewData.filter((x: any) => jobplanList.includes(x.jobPlanNumber)).map((x: any) => x.changeItemId);
      let changeItemListParts = this.partsViewData.filter((x: any) => jobplanList.includes(x.jobPlanNumber)).map((x: any) => x.changeItemId);
      // selectedItems = [...this.labourSelectedIds];
      let selectedItems = ''
      if (changeItemListParts.length > 0) {
        selectedItems = changeItemListLabour.filter((x: any) => x > 0).join(', ') + (',') + changeItemListParts.filter((x: any) => x > 0).join(', ');
      } else {
        selectedItems = changeItemListLabour.filter((x: any) => x > 0).join(', ')
      }
      let payload = {
        isSelectedAll: false,
        changeRequestId: this.crNo,
        selectedItems: selectedItems
      }
      this.jobPlanService.ClearJobPlanLabour(payload).subscribe({
        next: (response: any) => {
          if (response) {
            let clearAllResponse = `${changeItemListLabour.length} Labour & ${changeItemListParts.length} Part record(s) cleared from CR successfully`
            this.labourViewData = this.labourViewData.filter((x: any) => !changeItemListLabour.includes(x.changeItemId));
            this.partsViewData = this.partsViewData.filter((x: any) => !changeItemListParts.includes(x.changeItemId));
            this.commonService.showNotificationMessage(clearAllResponse, 'success', 'center');
            this.labourSelectedIds.clear();
            this.getPartsViewData();
            this.setHeaderMessage();
          }
        }
      });
    }
  }

  removeDataItem(id: any): any {
    let jpnum = this.findJobPlanNumberByChangeItemId(id);
    this.deleteCount.deleteLabour += this.labourViewData.filter(data => data.jobPlanNumber == jpnum && data.id < 0).length;
    this.labourViewData = this.labourViewData.filter(data => data.jobPlanNumber !== jpnum);
    this.deleteCount.deleteParts += this.partsViewData.filter(data => data.jobPlanNumber == jpnum && data.id < 0).length;
    this.partsViewData = this.partsViewData.filter(data => data.jobPlanNumber !== jpnum);
    this.setHeaderMessage();
  }

  findJobPlanNumberByChangeItemId(changeItemId: any): any {
    const item = this.labourViewData.find(data => data.changeItemId === changeItemId);
    return item ? item.jobPlanNumber : null;
  }
  closeActionPopup(status: boolean) {
    this.cSelectedRow = {};
    this.popUpOpenFieldChangeItemId = 0;
    this.popupTitle = "";
    this.popupShow = status;
    this.popupTccShow = status;
    this.searchPlaceHolder = "";
    this.searchText = '';
    this.serviceTypeList = [];
    this.serviceTypeSelectColumn = [];
    this.skip = 0;
    this.tccpageSize = 10;
  }

  removeLabourItem(changeItemId: number, dataItem: any) {

    let index = this.labourViewData.findIndex(data => data.changeItemId == changeItemId);
    let ogIndex = this.labourOGData.findIndex(data => data.changeItemId == changeItemId);

    if (this.labourViewData[index].acdAction === 'Add') {

      if (this.labourViewData[index].id < 0) {
        this.labourViewData.splice(index, 1);

      } else {
        // this.deleteLabourViewData.push(...deleteRecord);
        let payload = {
          ids: this.labourViewData[index].changeItemId.toString(),
          isEquipmentRouteDeleted: true
        }
        this.jobPlanService.deleteLabour(payload).subscribe({
          next: (response: any) => {
            if (response) {
              this.commonService.showNotificationMessage(response, 'success', 'center');
              this.labourViewData.splice(index, 1);
            }
          }
        });
      }


    } else {
      const currentColor = this.labourViewData[index].color; // Preserve color

      this.labourViewData[index] = {
        ...this.labourOGData[ogIndex],
        acdAction: 'Delete',
        id: this.labourViewData[index].id,
        acdActionLabel: 'Delete',
        operationId: 3,
        view_equipTagNumber: this.labourViewData[index].view_equipTagNumber,
        view_mwoNumber: this.labourViewData[index].view_mwoNumber,
        view_mwoProblemDescription: this.labourViewData[index].view_mwoProblemDescription,
        color: currentColor // Restore color
      };

      this.setHeaderMessage()
    }

    this.labourViewData = [...this.labourViewData];

  }

  /**
   * 
    Create new - > MAX(isCreateNew ,  iscopy = 0) + 1
    Copy - MAX(isCopy, iscreatenew = 0) + 1
    Update -  MAX((iscreatenew = 0 + iscopy = 0)) + 1
   * @returns 
   */
  generateRowNumber(type: string, isCreateNew: number, iscopy: number) {

    let newRow = 0;

    if (type == 'labour') {
      // create new
      newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 1 && data.iscopy == 0).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);
      return


      // create 
      if (isCreateNew == 1 && iscopy == 0) {
        newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 1 && data.iscopy == 0).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);
      }
      //Copy
      if (isCreateNew == 0 && iscopy == 1) {
        newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 0 && data.iscopy == 1).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);

      }
      //Update
      if (isCreateNew == 0 && iscopy == 0) {
        newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 0 && data.iscopy == 0).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);
      }

    } else if (type == 'part') {

      newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 1 && data.iscopy == 0).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);
      return

      // create 
      if (isCreateNew == 1 && iscopy == 0) {
        newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 1 && data.iscopy == 0).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);
      }
      //Copy
      if (isCreateNew == 0 && iscopy == 1) {
        newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 0 && data.iscopy == 1).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);

      }
      //Update
      if (isCreateNew == 0 && iscopy == 0) {
        newRow = this.labourViewData.filter((data: any) => data.isCreateNew == 0 && data.iscopy == 0).reduce((pre: number, next: any) => (pre < next.rowNumber) ? next.rowNumber : pre, 0);
      }
    }

    return newRow + 1;

  }

  cloneLabourItem(changeItemId: number) {

    let index = this.labourViewData.findIndex(data => data.changeItemId == changeItemId)


    let clonelabour = {
      ...this.labourViewData[index], ...{
        lastJobPLanNumber: this.labourViewData[index]?.jobPlanNumber,
        acdAction: 'Add',
        "view_equipTagNumber": '',
        "view_mwoNumber": '',
        "view_mwoProblemDescription": '',
        "errorList": [],
        "modifiedFields": '',
        craft: '', opsSeq: 0, norms: '', description: '', duration: 0, crewSize: 0, icyn: '', percentageOverlap: 0, tccid: '',
        inspectionID: '', equipmentNumber: '', jobPackNo: '', fileName: '', url: '', fileDescription: '', textAttachments: '',
        operationId: 1,
        isAddedToCR: false,
        id: this.localadd,
        changeItemId: this.localadd,
        color: this.labourViewData[index]?.color,
        rowNumber: this.generateRowNumber('labour', this.labourViewData[index]?.isCreateNew, this.labourViewData[index].iscopy)
      }
    }
    this.labourViewData.splice(index + 1, 0, clonelabour);
    this.localadd--;
    this.getPartsViewData();
  }

  cloneLabourItemImport(data: any, index: number = 0) {
   
      let clonelabour = {
        ...data, ...{
          lastJobPLanNumber: data.jobPlanNumber,
          acdAction: 'Add',
          "view_equipTagNumber": '',
          "view_mwoNumber": '',
          "view_mwoProblemDescription": '',
          "errorList": [],
          "modifiedFields": '',
          operationId: 1,
          isAddedToCR: false,
          id: this.localadd,
          changeItemId: this.localadd,
          // check how to generate row number
          // rowNumber: this.generateRowNumber('labour', this.labourViewData[index]?.isCreateNew, this.labourViewData[index].iscopy)
        }
    }
    if (index > 0) {
      this.labourViewData.splice(index, 0, clonelabour);
    }
    else {
      this.labourViewData.push(clonelabour);
    }
      // this.labourViewData.splice(index + 1, 0, clonelabour);
      this.localadd--;
      this.getPartsViewData();
    
  }

  undoLabourById(changeItemId: number) {

    let index = this.labourViewData.findIndex((data: any) => data.changeItemId == changeItemId);
    let rIndex = this.labourOGData.findIndex(data => data.changeItemId == changeItemId);

    const preservedColor = this.labourViewData[index].color || this.labourOGData[rIndex].color;
    if (rIndex != -1 && (this.labourViewData[index].acdAction == 'Change' || this.labourViewData[index].acdAction == 'Delete')) {
      this.labourViewData[index] = {
        ...this.labourOGData[rIndex],
        id: this.labourViewData[index].id,
        errorList: [],
        fieldChangedList: [],
        fieldChangedListTrack: [],
        acdAction: 'No change',
        acdActionLabel: 'No change',
        isStaging: true,
        operationId: 3,        
        view_equipTagNumber: this.labourViewData[index].view_equipTagNumber,
        view_mwoNumber: this.labourViewData[index].view_mwoNumber,
        view_mwoProblemDescription: this.labourViewData[index].view_mwoProblemDescription,
        color: preservedColor
      }
      this.labourViewData = [...this.labourViewData];
    }
  }
  actionedListLabour: any[] = [];
  actionedListPart: any[] = [];

  bulkActionLabourNew() {
    this.actionedListLabour = [];
    const selectedIds = [...this.labourSelectedIds];
    if (selectedIds.length > 0) {
      if (this.bulkActionLabourValue == "No change") {
        for (let changeItemId of selectedIds) {
          let index = this.labourViewData.findIndex((data: any) => data.changeItemId == changeItemId);
          let rIndex = this.labourOGData.findIndex((data: any) => data.changeItemId == changeItemId);
          if (index > -1) {
            this.actionedListLabour.push({ oldActionName: this.labourViewData[index].acdAction, id: this.labourViewData[index].id });
            // acd action is delete
            if (this.labourViewData[index].acdAction == 'Delete') {
              this.labourViewData[index] = {
                ...this.labourOGData[rIndex],
                operationId: 3,
                id: this.labourViewData[index].id,
                acdAction: 'No change',
                isStaging: true,
                view_equipTagNumber: this.labourViewData[index].view_equipTagNumber,
                view_mwoNumber: this.labourViewData[index].view_mwoNumber,
                view_mwoProblemDescription: this.labourViewData[index].view_mwoProblemDescription
              };
            }
            // acd action is change
            else if (this.labourViewData[index].acdAction == 'Change') {
              this.labourViewData[index] = {
                ...this.labourOGData[rIndex],
                operationId: 3,
                id: this.labourViewData[index].id,
                acdAction: 'No change',
                fieldChangedList: [],
                modifiedFields: '',
                isStaging: true,
                view_equipTagNumber: this.labourViewData[index].view_equipTagNumber,
                view_mwoNumber: this.labourViewData[index].view_mwoNumber,
                view_mwoProblemDescription: this.labourViewData[index].view_mwoProblemDescription
              };
            }
            // acd action is add
            else if (this.labourViewData[index].acdAction == 'Add') {

              if (this.labourViewData[index].id < 0) {
                this.labourViewData[index].acdAction = 'No change';
              } else {
                this.labourViewData[index] = {
                  ...this.labourOGData[rIndex],
                  operationId: 3,
                  modifiedFields: '',
                  view_equipTagNumber: this.labourViewData[index].view_equipTagNumber,
                  view_mwoNumber: this.labourViewData[index].view_mwoNumber,
                  view_mwoProblemDescription: this.labourViewData[index].view_mwoProblemDescription

                }
              }
            }
          }
        }
        this.labourViewData = JSON.parse(JSON.stringify(this.labourViewData));
      }
      else if (this.bulkActionLabourValue == "Add Job Step") {
        for (let changeItemId of selectedIds) {
          this.cloneLabourItem(changeItemId);
          this.actionedListLabour.push({ oldActionName: 'Add', id: (this.localadd + 1) });
        }
      }
      else if (this.bulkActionLabourValue == "Delete Job Step") {

        let sliceArr: any = []

        for (let changeItemId of selectedIds) {
          let index = this.labourViewData.findIndex((data: any) => data.changeItemId == changeItemId);
          let rIndex = this.labourOGData.findIndex((data: any) => data.changeItemId == changeItemId);
          this.actionedListLabour.push({ oldActionName: this.labourViewData[index].acdAction, id: this.labourViewData[index].id, rowNumber: this.labourViewData[index].rowNumber });
          if (this.labourViewData[index].acdAction == 'Add') {
            this.localDeleteLabourData.push({ data: { ...this.labourViewData[index] }, lastIndex: index });
            // this.labourViewData.splice(index, 1);
            sliceArr.push(changeItemId);
          } else if (this.labourViewData[index].acdAction != 'Delete') {
            if (this.labourViewData[index].id <= 0) {
              this.localDeleteLabourData.push({ data: { ...this.labourViewData[index] }, lastIndex: index });
              // this.labourViewData.splice(index, 1);
              sliceArr.push(changeItemId);

            } else {
              this.labourViewData[index] = {
                ...this.labourOGData[rIndex],
                acdAction: 'Delete',
                id: this.labourViewData[index].id,
                acdActionLabel: 'Delete',
                operationId: 3,
                view_equipTagNumber: this.labourViewData[index].view_equipTagNumber,
                view_mwoNumber: this.labourViewData[index].view_mwoNumber,
                view_mwoProblemDescription: this.labourViewData[index].view_mwoProblemDescription
              };
            }
          }
          this.labourSelectedIds.delete(changeItemId)
        }
        // 
        if (sliceArr.length) {
          sliceArr.forEach((changeItemId: number) => {
            let cindex = this.labourViewData.findIndex((data: any) => data.changeItemId == changeItemId);
            this.labourViewData.splice(cindex, 1);
          });
        }
      }
      this.labourViewData = [...this.labourViewData];

      this.lastbulkActionLabourValue = this.bulkActionLabourValue;
    }
    this.labourSelectedIds.clear();
    this.getPartsViewData();

    this.labourActionApplied = this.actionedListLabour.length > 0 ? true : false;
  }


  undoLabourAction() {
    if (this.actionedListLabour.length > 0) {
      if (this.lastbulkActionLabourValue == "Add Job Step") {
        this.labourViewData = this.labourViewData.filter((x: any) => !this.actionedListLabour.some((y: any) => x.id == y.id));
      }
      else if (this.lastbulkActionLabourValue == "Delete Job Step") {
        this.labourViewData.filter((x: any) => this.actionedListLabour.some((y: any) => x.id == y.id)).forEach((x: any) => {
          let undoStateData = this.actionedListLabour.find((y: any) => x.id == y.id && y.acdAction != 'Add');
          if (undoStateData != undefined) {
            x.acdAction = undoStateData.oldActionName;
            x.acdId = this.commonService.setACDID(undoStateData.oldActionName);
            x.operationId = 3;
          }
        });
        // this.labourViewData = [...this.labourViewData, ...this.localDeleteLabourData];
        // this.localDeleteLabourData = [];
        // this.sortLabourData();

        this.localDeleteLabourData.forEach((element: any) => {
          this.labourViewData.splice(element.lastIndex, 0, element.data)
        });

        this.localDeleteLabourData = [];

      } if (this.lastbulkActionLabourValue == "No change") {
        this.labourViewData.filter((x: any) => this.actionedListLabour.some((y: any) => x.id == y.id)).forEach((x: any) => {
          let undoStateData = this.actionedListLabour.find((y: any) => x.id == y.id);
          if (undoStateData != undefined) {
            x.acdAction = undoStateData.oldActionName;
            x.acdId = this.commonService.setACDID(undoStateData.oldActionName);
            x.operationId = 3;
          }
        });
      }
    }
    this.LastUndoListLabour = [];
    this.actionedListLabour = [];
    this.labourActionApplied = false;
    this.commonService.showNotificationMessage("ACD Action changes in Labour undone.", "success", "center");
  }
  bulkActionPartsNew() {
    this.actionedListPart = [];
    const selectedIds = [...this.partsSelectedIds];
    if (selectedIds.length > 0) {
      if (this.bulkActionPartValue == "No change") {
        for (let changeItemId of selectedIds) {
          let index = this.partsViewData.findIndex((data: any) => data.changeItemId == changeItemId);
          let rIndex = this.partsOGData.findIndex((data: any) => data.changeItemId == changeItemId);

          if (index > -1) {
            this.actionedListPart.push({ oldActionName: this.partsViewData[index].acdAction, id: changeItemId });
            // acd action is delete
            if (this.partsViewData[index].acdAction == 'Delete') {
              this.partsViewData[index] = {
                ...this.partsOGData[rIndex],
                operationId: 3,
                id: this.partsViewData[index].id,
                acdAction: 'No change',
                isStaging: true,
                view_equipTagNumber: this.partsViewData[index].view_equipTagNumber,
                view_mwoNumber: this.partsViewData[index].view_mwoNumber,
                view_mwoProblemDescription: this.partsViewData[index].view_mwoProblemDescription
              };
            }
            // acd action is change
            else if (this.partsViewData[index].acdAction == 'Change') {
              this.partsViewData[index] = {
                ...this.partsOGData[rIndex],
                id: this.partsViewData[index].id,
                acdAction: 'No change',
                fieldChangedList: [],
                operationId: 3,
                modifiedFields: '',
                isStaging: true,
                view_equipTagNumber: this.partsViewData[index].view_equipTagNumber,
                view_mwoNumber: this.partsViewData[index].view_mwoNumber,
                view_mwoProblemDescription: this.partsViewData[index].view_mwoProblemDescription
              };
            }
            // acd action is add
            else if (this.partsViewData[index].acdAction == 'Add') {

              if (this.partsViewData[index].id < 0) {
                this.partsViewData[index].acdAction = 'No change';
              } else {
                this.partsViewData[index] = {
                  ...this.partsOGData[rIndex],
                  operationId: 3,
                  modifiedFields: '',
                  view_equipTagNumber: this.partsViewData[index].view_equipTagNumber,
                  view_mwoNumber: this.partsViewData[index].view_mwoNumber,
                  view_mwoProblemDescription: this.partsViewData[index].view_mwoProblemDescription

                }
              }
            }
          }
        }
        this.partsViewData = JSON.parse(JSON.stringify(this.partsViewData));
      }
      else if (this.bulkActionPartValue == "Add Part") {
        for (let changeItemId of selectedIds) {
          this.clonePartItem(changeItemId);
        }
      }
      else if (this.bulkActionPartValue == "Delete Part") {

        for (let changeItemId of selectedIds) {
          let index = this.partsViewData.findIndex((data: any) => data.changeItemId == changeItemId);
          let rIndex = this.partsOGData.findIndex((data: any) => data.changeItemId == changeItemId);

          if (this.partsViewData[index].acdAction == 'Add') {
            this.deletePartsViewData.push({ ...this.partsViewData[index] });
            this.partsViewData.splice(index, 1);
          } else if (this.partsViewData[index].acdAction != 'Delete') {


            if (this.partsViewData[index].id <= 0) {
              this.partsViewData.splice(index, 1);
            } else {
              this.partsViewData[index] = {
                ...this.partsOGData[rIndex],
                acdAction: 'Delete',
                id: this.partsViewData[index].id,
                acdActionLabel: 'Delete',
                operationId: 3,
                view_equipTagNumber: this.partsViewData[index].view_equipTagNumber,
                view_mwoNumber: this.partsViewData[index].view_mwoNumber,
                view_mwoProblemDescription: this.partsViewData[index].view_mwoProblemDescription
              };
            }

          }
          this.partsSelectedIds.delete(changeItemId)
        }
      }
      this.partsViewData = [...this.partsViewData];

      this.lastbulkActionPartValue = this.bulkActionPartValue;
    }


    this.partsSelectedIds.clear();
    this.partActionApplied = this.actionedListPart.length > 0 ? true : false;
    this.getPartsViewData();
  }
  bulkActionParts() {
    const selectedIds = [...this.partsSelectedIds];
    if (this.bulkActionPartValue == 'Add Part') {
      for (let changeItemId of selectedIds) {
        this.clonePartItem(changeItemId);
      }
    } else if (this.bulkActionPartValue == 'Delete Part') {
      for (let changeItemId of selectedIds) {
        this.removePartItem(changeItemId); //check condition
        this.partsSelectedIds.delete(changeItemId);
      }
    } else if (this.bulkActionPartValue == 'No change') {
      for (let changeItemId of selectedIds) {

        let index = this.partsViewData.findIndex((data: any) => data.changeItemId == changeItemId);
        let rIndex = this.partsOGData.findIndex((data: any) => (data.changeItemId == changeItemId));

        if (this.partsViewData[index].acdAction == 'Change') {
          this.partsViewData[index] = { ...this.partsOGData[rIndex], id: this.partsViewData[index].id, acdAction: 'No change', isStaging: true };
        } else if (this.partsViewData[index].acdAction == 'Add') {
          this.removePartItem(changeItemId);//check condition
          this.partsSelectedIds.delete(changeItemId)
        } else if (this.partsViewData[index].acdAction == 'Delete') {
          this.partsViewData[index] = { ...this.partsOGData[rIndex], id: this.partsViewData[index].id, acdAction: 'No change', isStaging: true };
        }
      }
    }
  }

  sortLabourData() {
    this.labourViewData.sort((a: any, b: any) => {
      if (a.jobPlanNumber === b.jobPlanNumber) {
        return a.opsSeq - b.opsSeq;
      }
      return b.jobPlanNumber.localeCompare(a.jobPlanNumber);
    });
  }
  undoPartsAction() {

  }
  // Parts
  removePartItem(changeItemId: number) {
    let index = this.partsViewData.findIndex(data => data.changeItemId == changeItemId);
    let ogindex = this.partsOGData.findIndex(data => data.changeItemId == changeItemId);
    if (this.partsViewData[index].acdAction == 'Add') {
      if (this.partsViewData[index].id <= 0) {
        this.partsViewData.splice(index, 1);
      } else {
        let payload = {
          ids: this.partsViewData[index].changeItemId.toString(),
          isEquipmentRouteDeleted: true
        }
        this.jobPlanService.deletePart(payload).subscribe({
          next: (response: any) => {
            if (response) {
              this.commonService.showNotificationMessage(response, 'success', 'center');
              this.partsViewData.splice(index, 1);
            }
          }
        });
      }

      this.partsViewData = this.partsViewData.filter(data => data.changeItemId !== changeItemId);
      if (this.labourSelectedIds.has(changeItemId)) {
        this.labourSelectedIds.delete(changeItemId);
      }

    } else {
      this.partsViewData[index] = {
        ...this.partsOGData[ogindex],
        id: this.partsViewData[index].id,
        acdAction: 'Delete',
        isStaging: true,
        acdActionLabel: 'Delete',
        operationId: 3,
        view_equipTagNumber: this.partsViewData[index].view_equipTagNumber,
        view_mwoNumber: this.partsViewData[index].view_mwoNumber,
        view_mwoProblemDescription: this.partsViewData[index].view_mwoProblemDescription
      };
    }

    this.partsViewData = [...this.partsViewData];
    this.showAllParts = true;
    this.getPartsViewData();
    this.setHeaderMessage();
  }

  clonePartItem(changeItemId: number) {
    const indexToClone = this.partsViewData.findIndex(item => item.changeItemId === changeItemId);
    let isTemplateValue = (this.partsViewData[indexToClone].acdAction.toLocaleLowerCase() == 'no change') && (this.partsViewData[indexToClone].item == 0)
    let cloneParts = {
      ...this.partsViewData[indexToClone],
      ...{
        acdAction: 'Add',

        "view_equipTagNumber": '',
        "view_mwoNumber": '',
        "view_mwoProblemDescription": '',

        item: '',
        quantity: 0,
        // branchPlant: '',
        compBranchPlant: '',
        // operationSequence: '',
        operationId: 1,
        rowNumber: this.generateRowNumber('part', this.labourViewData[indexToClone]?.isCreateNew, this.labourViewData[indexToClone]?.iscopy),
        isAddedToCR: false,
        // isNewJobPlan : false,
        // isCopy : false,
        // isCreateNew : false,
        id: this.localadd,
        changeItemId: this.localadd,
        fiedldchangeList: [],
        errorList: [],
        modifiedFields: '',
        isTemplate: isTemplateValue ? false : this.partsViewData[indexToClone]?.isTemplate
      }
    }
     // this.partsViewData.push(cloneParts);
    this.partsViewData.splice(indexToClone + 1, 0, cloneParts);
    this.showAllParts = true;
    this.localadd--;
    this.getPartsViewData();

  }

  clonePartItemImport(data: any, index: number = 0) {
    // let isTemplateValue = (data.acdAction.toLocaleLowerCase() == 'no change') && (data.item == 0)

    let cloneParts = {
      ...data,
      ...{
        acdAction: 'Add',
        "view_equipTagNumber": '',
        "view_mwoNumber": '',
        "view_mwoProblemDescription": '',
        operationId: 1,
        isAddedToCR: false,
        id: this.localadd,
        changeItemId: this.localadd,
        fiedldchangeList: [],
        errorList: [],
        modifiedFields: '',
        isItemChanged: true,
        isNewJobPlan: true,
        isCopy: false,
        isCreateNew: false,
        isTemplate: false,
        // isTemplate : isTemplateValue ? false : this.partsViewData[indexToClone]
        // vishal check how to generate row number
        // rowNumber: this.generateRowNumber('part', this.labourViewData[indexToClone]?.isCreateNew, this.labourViewData[indexToClone]?.iscopy),

      }
    }
    if (index > 0) {
      this.partsViewData.splice(index, 0, cloneParts);
    }
    else {
      this.partsViewData.push(cloneParts);
    }    
    // this.partsViewData.splice(indexToClone + 1, 0, cloneParts);
    this.localadd--;

  }

  undoPartById(changeItemId: number) {

    let index = this.partsViewData.findIndex((data: any) => data.changeItemId == changeItemId);
    let rIndex = this.partsOGData.findIndex((data: any) => (data.changeItemId == changeItemId));

    if (rIndex != -1 && (this.partsViewData[index].acdAction.toLowerCase() == 'delete' || this.partsViewData[index].acdAction.toLocaleLowerCase() == 'change')) {
      this.partsViewData[index] = {
        ...this.partsOGData[rIndex],
        id: this.partsViewData[index].id,
        errorList: [],
        fieldChangedList: [],
        fieldChangedListTrack: [],
        acdAction: 'No change',
        isStaging: true,
        operationId: 3,
        view_equiptagNumber: this.partsViewData[index].view_equipTagNumber,
        view_mwoNumber: this.partsViewData[index].view_mwoNumber,
        view_mwoProblemDescription: this.partsViewData[index].view_mwoProblemDescription
      };
      this.getPartsViewData();
    }
    this.showAllParts = true;
    this.getPartsViewData();


  }
  SortPartData() {
    this.partsViewData.sort((a: any, b: any) => {
      if (a.jobPlanNumber === b.jobPlanNumber) {
        return a.operationSequence - b.operationSequence;
      }
      return b.jobPlanNumber.localeCompare(a.jobPlanNumber);
    });
    this.getPartsViewData();
  }
  addPartRow() {

    if (this.labourSelectedIds.size <= 0) {
      return
    }

    for (let changeItemId of this.labourSelectedIds) {

      let index = this.labourViewData.findIndex(data => data.changeItemId == changeItemId)

      const cData = this.labourViewData[index]

      let clonePartRow = {
        ...cData,
        ...{
          'id': this.localadd,
          'changeItemId': this.localadd,
          acdAction: 'Add',
          equipTagNumber: cData?.equipTagNumber ?? '',
          isStaging: cData?.isStaging ?? '',
          jobPlanNumber: cData?.jobPlanNumber ?? '',
          modifiedFields: '',
          mwoNumber: cData?.mwoNumber ?? '',
          mwoProblemDescription: cData?.mwoProblemDescription ?? '',
          isNewJobPlan: true,
          item: '',
          branchPlant: cData?.branchPlant ?? '',
          compBranchPlant: '',
          operationSequence: cData?.opsSeq,
          quantity: 0,
          itemDescription: '',
          isCopy: cData?.isCopy,
          isTemplate: false,
          isCreateNew: cData?.isCreateNew,
          operationId: 1,
          "view_equipTagNumber": '',
          "view_mwoNumber": '',
          "view_mwoProblemDescription": '',
          fieldChangedList: [],
          fieldChangedListTrack: []
        }
      }
      this.partsViewData.push(clonePartRow);
      this.localadd--;
    }
    this.showAllParts = true;

    this.SortPartData()
  }

  getPartsViewData(isLabourSelected : boolean = false) {
    let changeItemIds = [...this.labourSelectedIds];

    if (changeItemIds.length == 0 || this.showAllParts) {
      this.filterPartsViewData = [...this.partsViewData];
      this.showAllParts = false;
      return;
    }

    const jobPlanDetails = changeItemIds
      .map(changeItemId => {
        const matchedItem = this.labourViewData.find(item => item.changeItemId === changeItemId);
        return matchedItem ? { jobPlanNumber: matchedItem.jobPlanNumber, opSeq: matchedItem.opsSeq } : null;
      })
      .filter(detail => detail !== null);
    this.filterPartsViewData = this.partsViewData.filter(data => {
      return jobPlanDetails.some((detail: any) => detail.jobPlanNumber == data.jobPlanNumber);
    });

    if (!isLabourSelected && changeItemIds.length == 0 ) {
      this.setHeaderMessage();
    }

  }



  imported(data: ImportData) {
    if (data.cancel) {
      this.closeFileUploadPopup();
      return;
    }
    if (data.validationMsgs.length > 0) {
      this.commonService.showNotificationMessage(data.validationMsgs.join("<br>"), "error", "center");
    } else {
      const newData = data.data;
      if (!newData.length) {
        return this.commonService.showNotificationMessage('upload file is empty', "error", "center");
      }

      if (this.popupOpenField == 'labour') {

        let errorMessage = '';
        newData.forEach((x: any, index: any) => {
          if (isNaN(x.percentageOverlap)) {
            errorMessage += 'Row ' + (index + 1) + ' | percentage overlap should be a number </br>'
          }
          if (isNaN(x.duration)) {
            errorMessage += 'Row ' + (index + 1) + ' | duration should be a number </br>'
          }
          if (isNaN(x.opsSeq)) {
            errorMessage += 'Row ' + (index + 1) + ' | operation sequence  should be a number </br>'
          }
          if (isNaN(x.crewSize)) {
            errorMessage += 'Row ' + (index + 1) + ' | crew Size should be a number </br>'
          }
        })
        if (errorMessage.length > 0) {
          this.commonService.showNotificationMessage(errorMessage, "error", "center");
          this.closeActionPopup(false);
        } else {
          newData.forEach((x: any, index: any) => {
            x.rowNumber = index;
            x.emdmKey = x.emdmKey?.toString() ?? '';
            x.equipTagNumber = x.equipTagNumber?.toString() ?? '';
            x.mwoNumber = x.mwoNumber?.toString() ?? '';
            x.mwoProblemDescription = x.mwoProblemDescription?.toString() ?? '';
            x.jobPlanNumber = x.jobPlanNumber?.toString() ?? '';
            x.jobPlanDescription = x.jobPlanDescription?.toString() ?? '';
            x.performanceStandard = x.performanceStandard?.toString() ?? '';
            x.branchPlant = x.branchPlant?.toString() ?? '';
            x.craft = x.craft?.toString() ?? '';
            x.description = x.description?.toString() ?? '';
            x.icyn = x.icyn?.toString() ?? '';
            x.tccid = x.task?.toString() ?? '';
            x.inspectionID = x.inspectionID?.toString() ?? '';
            x.equipmentNumber = x.equipmentNumber?.toString() ?? '';
            x.fileName = x.fileName?.toString() ?? '';
            x.url = x.url?.toString() ?? '';
            x.fileDescription = x.fileDescription?.toString() ?? '';
            x.textAttachments = x.textAttachments?.toString() ?? '';
            x.jbcd = x.jbcd?.toString() ?? '';
            x.jobPackNo = x.jobPackNo?.toString() ?? '';
            x.messageNumber = x.messageNumber?.toString() ?? '';
            x.operationSequence = x.opsSeq ?? 0;
            x.percentageOverlap = x.percentageOverlap ?? 0;
            x.duration = x.duration ?? 0;
            x.crewSize = x.crewSize ?? 0;
          })
          this.ImportJobPlanBuildLabour(newData).then((vData: any) => {

            if (vData.item2) {
              let msg = vData.item2;
              if (typeof msg === 'string') {
                msg = msg
                  .replace(/[\r\n]/g, '') // removes all carriage returns and newlines
                  .split(';')
                  .map(data => data.trim()) // trims each item
                  .filter(data => data.length > 0); // removes empty strings
              } else {
                msg = [];
              }
              let errorMsg = `There is ${msg.length} error field: </br>`;
              errorMsg = errorMsg + msg.join('<br/>');
              this.commonService.showNotificationMessage(errorMsg, "error", "center");
            } else if (vData.item1) {

              vData.item1.forEach((x: any, index: number) => {

                let viewDataIndex = this.labourViewData.findIndex((y: any) => x.id == y.id && x.emdmKey == y.emdmKey);

                if (viewDataIndex >= 0) {

                  if (x.modifiedFields) {
                    const fieldChangedList = x.modifiedFields.split(";").filter((data: any) => data?.trim());
                    if (fieldChangedList.length) {
                      fieldChangedList.forEach((field: string) => {

                        if (field == 'acdAction') {

                          if (fieldChangedList.length == 1 && x.acdAction == 'Delete') {

                            if (this.labourViewData[viewDataIndex].acdAction == 'Add') {
                              this.labourViewData.splice(viewDataIndex, 1);
                              return
                            }
                            if (this.labourViewData[viewDataIndex].acdAction == 'change') {
                              this.labourViewData[viewDataIndex].acdAction = 'Delete';
                              return
                            }
                            if (this.labourViewData[viewDataIndex].acdAction == 'No change') {
                              this.labourViewData[viewDataIndex].acdAction = 'Delete';
                              return;
                            }
                          }
                        }

                        // let findex = this.labourViewData[viewDataIndex].fieldChangedList.findIndex(field);
                        // add in fieldChangedList when not exist
                        // if (findex == -1) {
                        // this.labourViewData[viewDataIndex].fieldChangedList.push(field);
                        this.onValueChange(this.labourViewData[viewDataIndex], field, x[field]);
                        // }

                        // update modified field
                        this.labourViewData[viewDataIndex][field] = x[field];
                        // this.labourViewData[viewDataIndex].operationId = 3;  // change in save time
                        //this.labourViewData[viewDataIndex].acdAction = 'Change';

                      })
                    }
                  }

                } else if (x.emdmKey == null) {
                  this.cloneLabourItemImport(x,index)
                }
              });
            }

            this.popupTitle = "";
            this.popupOpenField = "";
            this.closeActionPopup(false);
            this.closeFileUploadPopup();
          });
        }
      }
      else if (this.popupOpenField == 'parts') {

        let errorMessage = ''
        newData.forEach((x: any, index: any) => {
          if (isNaN(x.item)) {
            errorMessage += 'Row ' + (index + 1) + ' | item should be a number </br>'
          }
          if (isNaN(x.quantity)) {
            errorMessage += 'Row ' + (index + 1) + ' | quantity should be a number </br>'
          }
          if (isNaN(x.operationSequence)) {
            errorMessage += 'Row ' + (index + 1) + ' | operation sequence  should be a number </br>'
          }
        })
        if (errorMessage.length > 0) {
          this.commonService.showNotificationMessage(errorMessage, "error", "center");
          this.closeActionPopup(false);
        } else {
          //SKip records if item & qty are zero
          const filteredData = newData.filter((x: any) => {
            // Check if partsViewData has a matching emdmKey with any zero value
            const hasZeroComboInParts = this.partsViewData.some((part: any) =>
              part.emdmKey === x.emdmKey &&
              (part.quantity === 0 && part.item === 0 && part.operationSequence === 0)
            );
            // Remove from newData if such a zero combo exists in partsViewData
            return !hasZeroComboInParts;
          });


          filteredData.forEach((x: any, index: any) => {
            x.rowNumber = index;
            x.emdmKey = x.emdmKey?.toString() ?? '';
            x.equipTagNumber = x.equipTagNumber?.toString() ?? '';
            x.mwoNumber = x.mwoNumber?.toString() ?? '';
            x.mwoProblemDescription = x.mwoProblemDescription?.toString() ?? '';
            x.jobPlanNumber = x.jobPlanNumber?.toString() ?? '';
            x.branchPlant = x.branchPlant?.toString() ?? '';
            x.compBranchPlant = x.compBranchPlant?.toString() ?? '';
            x.operationSequence = x.operationSequence ?? 0;
            x.quantity = x.quantity ?? 0;
            x.item = x.item ?? 0;
          })
          filteredData.forEach((x: any) => {
            x.isItemChanged = false;
            x.isRowNOChange = false;
            let citemID = x?.emdmKey?.split('-')[0];
            let cindex = this.partsExportData.findIndex((data: any) => data.changeItemId == citemID);
            if (cindex > -1 && x.item != this.partsExportData[cindex].item) {
              x.isItemChanged = true
            }
            if (cindex > -1 && this.partsExportData[cindex].acdAction == 'No change' && x.item == this.partsExportData[cindex].item && x.quantity == this.partsExportData[cindex].quantity && x.operationSequence == this.partsExportData[cindex].operationSequence) {
              x.isRowNOChange = true
            }
          });
          this.ImportJobPlanBuildParts(filteredData).then((vData: any) => {
            if (vData.item2) {
              
              let msg = vData.item2;
              if (typeof msg === 'string') {
                msg = msg
                  .replace(/[\r\n]/g, '') // removes all line breaks
                  .split(';')
                  .map(data => data.trim()) // trims each item
                  .filter(data => data.length > 0);
              } else {
                msg = [];
              }                  
              const cleanedMsg = vData.item2
                .replace(/\r/g, '')               // Remove carriage returns
                .split('\n')                      // Split by newline
                .map((line:any) => line.trim())        // Trim each line
                .filter((line: any) => line.length > 0) // Remove empty lines

              const errorMsg = `There are ${cleanedMsg.length} error fields:<br/>` + msg.join('<br/>');

              this.commonService.showNotificationMessage(errorMsg, "error", "center");
            } else if (vData.item1) {
              this.commonService.showNotificationMessage("Import into Parts successful", 'success', 'center', 200, false);
              let COUNT = 0;
              vData.item1.forEach((nData: any, index: number) => {
                // vishal check delete cash in labor  and part
                COUNT++;
                let viewDataIndex = this.partsViewData.findIndex((oData: any) => oData.emdmKey == nData.emdmKey);
                if (viewDataIndex >= 0) {
                  if (nData.modifiedFields) {
                    const fieldChangedList = nData.modifiedFields.split(';').filter((data: any) => data?.trim());
                    if (fieldChangedList.length) {
                      fieldChangedList.forEach((field: any) => {

                        if (field == 'acdAction') {

                          if (fieldChangedList.length == 1 && nData.acdAction == 'Delete') {
                            if (this.partsViewData[viewDataIndex].acdAction == 'Add') {
                              this.partsViewData.splice(viewDataIndex, 1);
                              return

                            }
                            if (this.partsViewData[viewDataIndex].acdAction == 'change') {
                              this.partsViewData[viewDataIndex].acdAction = 'Delete';
                              return

                            }
                            if (this.partsViewData[viewDataIndex].acdAction == 'No change') {
                              this.partsViewData[viewDataIndex].acdAction = 'Delete';
                              return;

                            }
                          }
                        }

                        // if (nData.acdAction == 'No change') {
                        //   if (fieldChangedList.length > 1) {
                        //     this.partsViewData[viewDataIndex].acdAction = 'Change';
                        //     return
                        //   }
                        //   return
                        // }

                        // let findex = this.partsViewData[viewDataIndex].fieldChangedList.findIndex(field);
                        // add in fieldChangedList when not exist
                        // if (findex == -1) {
                        // this.partsViewData[viewDataIndex].fieldChangedList.push(field);
                        this.onPartValueChange(this.partsViewData[viewDataIndex], field, nData[field]);
                        // }
                        // update modified field
                        this.partsViewData[viewDataIndex][field] = nData[field];
                        // this.partsViewData[viewDataIndex].operationId = 3; // update in save time
                        // this.partsViewData[viewDataIndex].acdAction = 'Change';
                      })
                    }
                  }
                  this.partsViewData[viewDataIndex].acdAction = this.action[nData.acdAction];
                } if (nData.emdmKey == null) {
                  this.clonePartItemImport(nData, index);
                }
              })
            }

            this.popupTitle = "";
            this.popupOpenField = "";
            this.closeActionPopup(false);
            this.closeFileUploadPopup();
            //this.SortPartData();  commenting as the sorting is happening directly from database
            this.getPartsViewData();
          })
        }
      }
      this.setHeaderMessage();
      // this.sortLabourData();
      // this.SortPartData();
    }

  }

  clickExport(event: Event, exportType: string): void {

    if (exportType == 'labour') {

      let custName = "export_labour_CR" + this.crNo + "_" + this.commonService.getCurrentUTCDateTime();
      let labourExportColoumns = [
        'EMDM Key',              // A
        'Equip Tag Number',      // B
        'MWO Number',            // C
        'Mwo Problem Description', // D
        'Job Plan Number',       // E
        'Job Plan Description',  // F
        'Performance Standard',  // G
        'Branch',                // H
        'Craft',                 // I
        'Operation Sequence',    // J
        'Description',           // K
        'Duration',              // L
        'Crew Size',             // M
        'IC Y_N',                // N
        'Percentage Overlap',    // O
        'Task',                  // P
        'Message Number',        // Q
        'Equipment Number',      // R
        'File Name',             // S
        'URL',                   // T
        'File Description',      // U
        'Text Attachment',       // V
        'JBCD',                  // W
        'Job Pack No'            // X
      ]

      let exportData = [];
      exportData = this.labourExportData
        .map((data: any) => {
          return {
            emdmKey: data.emdmKey ?? '', // A
            equipTagNumber: data.equipTagNumber ?? '', // B
            mwoNumber: data.mwoNumber ?? '', // C
            mwoProblemDescription: data.mwoProblemDescription ?? '', // D
            jobPlanNumber: data.jobPlanNumber ?? '', // E
            jobPlanDescription: data.jobPlanDescription ?? '', // F
            performanceStandard: data.performanceStandard ?? '', // G
            branchPlant: data.branchPlant ?? '', // H
            craft: data.craft ?? '', // I
            opsSeq: data.opsSeq ?? '', // J
            description: data.description ?? '', // K
            duration: data.duration ?? '', // L
            crewSize: data.crewSize ?? '', // M
            icyn: data.icyn ?? '', // N
            percentageOverlap: data.percentageOverlap ?? '', // O
            tccid: data.tccid ?? '', // P
            messageNumber: data.messageNumber ?? '', // Q
            equipmentNumber: data.equipmentNumber ?? '', //  R
            fileName: data.fileName ?? '', // S
            url: data.url ?? '', // T
            fileDescription: data.fileDescription ?? '', // U
            textAttachments: data.textAttachments ?? '', // V
            jbcd: data.jbcd ?? '',// W
            jobPackNo: data.jobPackNo ?? '', // X


          }


        });


      this.exportService.exportExcel(exportData, [labourExportColoumns], custName);
      this.commonService.showNotificationMessage(
        'file downloaded successfully',
        'success',
        'center'
      );

    } else if (exportType == 'parts') {

      let custName = "export_parts_CR" + this.crNo + "_" + this.commonService.getCurrentUTCDateTime();
      let partsExportColoumns = [
        'EMDM Key', // A
        'Equip Tag Number', // B
        'MWO Number', // C
        'Mwo Problem Description', // D
        'Job Plan Number', // E
        'Branch', // F
        'Item Number', // G
        'Quantity', // H
        'Comp Branch', // I
        'Operation Sequence' // J
      ]

      let exportData = [];

      exportData = this.partsExportData.map((data: any) => {
        return {
          emdmKey: data.emdmKey, // A
          equipTagNumber: data.equipTagNumber, // B
          mwoNumber: data.mwoNumber, // C
          mwoProblemDescription: data.mwoProblemDescription, // D
          jobPlanNumber: data.jobPlanNumber, // E
          branchPlant: data.branchPlant, // F
          item: data.item, // G
          quantity: data.quantity, // H
          compBranchPlant: data.compBranchPlant, // I
          operationSequence: data.operationSequence, // J
        }
      });


      this.exportService.exportExcel(exportData, [partsExportColoumns], custName);
      this.commonService.showNotificationMessage(
        'file downloaded successfully',
        'success',
        'center'
      );
    }
  }

  cSelectedRow: any = {};
  openActionPopup(fieldName: string, dataItem: any = null) {
    this.cSelectedRow = dataItem;
    this.popupOpenField = fieldName;

    // popupShow
    if (this.popupOpenField == 'jobPlanNumber') {
      this.popupTitle = "Search Job Plan Number for Tag " + dataItem.equipTagNumber + " , MWO " + (dataItem.mwoNumber ?? 0);
      this.serviceTypeList = this.jobPlanData;
      this.serviceTypeSelectColumn = this.jobplanSelectColumn;
      this.searchPlaceHolder = "Search Job Plan Number";
      this.popupWidth = 800;
      this.popupBtnText = "Select Item";

      // this.searchText = dataItem.jobPlanNumber

      this.popupGridColumn = [
        { field: 'jobPlanNumber', title: 'Job Plan Number', width: 330, isSearchProperty: true, showSpecialStatus: true },
        { field: 'branch', title: 'Branch', width: 280, isSearchProperty: true },
      ];

      this.getJobPlanPopupData();
    } else if (this.popupOpenField == 'craft') {
      this.popupTitle = "Search Craft for Tag " + dataItem.equipTagNumber + " , MWO " + (dataItem.mwoNumber ?? 0) + ",  Job Plan " + dataItem.jobPlanNumber;
      this.serviceTypeList = this.craftData;
      this.serviceTypeSelectColumn = this.craftSelectColumn;
      this.searchPlaceHolder = "Insert total or partial Lead Craft code/description to search for";
      this.popupWidth = 800;
      this.popupBtnText = "Select Item";
      this.popupHeight = 440;
      this.popupGridColumn = [
        { field: 'code', title: 'Code', width: 120, isSearchProperty: true },
        { field: 'description', title: 'Description', width: 280, isSearchProperty: true },
      ];
      this.leadCraftPopupData();
    } else if (this.popupOpenField == 'tccid') {
      this.popupTitle = "Search TCC for Tag# " + dataItem.equipTagNumber + " , MWO " + (dataItem.mwoNumber ?? 0) + "  Job Plan " + dataItem.jobPlanNumber;
      this.serviceTypeList = this.tccData;
      this.serviceTypeSelectColumn = this.tccColumn;
      this.searchPlaceHolder = "Insert total or partial Task ID to search for";
      this.tccpopupWidth = 800;
      this.popupBtnText = "Select Task";
      this.tccpopupHeight = 680;
      this.tccpageSize = 10;
      this.popupGridColumn = [
        { field: 'taskID', title: 'Task ID', width: 80, isSearchProperty: true },
        { field: 'task', title: 'Task', width: 360, isSearchProperty: true },
        { field: 'consequence', title: 'Consequence', width: 100, isSearchProperty: false },
      ];

      this.getTccidPopupData()
    } else if (this.popupOpenField == 'item') {
      this.popupTitle = "Search Item for Tag " + dataItem.equipTagNumber + " , MWO " + dataItem.mwoNumber + "  Job Plan " + dataItem.jobPlanNumber;
      this.serviceTypeList = this.tccData;
      this.serviceTypeSelectColumn = this.tccColumn;
      this.searchPlaceHolder = "Insert total or partial Task ID to search for";
      this.popupWidth = 800;
      this.popupHeight = 440;
      this.popupBtnText = "Select Task";
      this.selectedbranch = dataItem.branchPlant.trim();
      this.popupGridColumn = [
        { field: 'itemNumber', title: 'Item Number', width: 120, isSearchProperty: true },
        { field: 'description', title: 'Description', width: 280, isSearchProperty: true },
        { field: 'branch', title: 'Branch', width: 120, isSearchProperty: true },
      ];

      this.GetItemSearch()
    } else if (this.popupOpenField == 'labour') {
      this.fieldValidationInput = this.fieldValidationInput_Labour;
      this.popupTitle = "Import new changes to change request #" + this.crNo;
      this.popupHeight = 250;
      this.popupWidth = 500;
      this.showFileUploadPopup = true;
    } else if (this.popupOpenField == 'parts') {
      this.fieldValidationInput = this.fieldValidationInput_Parts;
      this.popupTitle = "Import new changes to change request #" + this.crNo;
      this.popupHeight = 250;
      this.popupWidth = 500;
      this.showFileUploadPopup = true;
    }
  }
  popupPageChanged(event: any) {
    this.skip = event.skip;
    if (this.popupOpenField == 'tccid') {
      this.tccpageSize = event.pageSize;
    } else {
      this.pageSize = event.pageSize;
    }
    this.searchText = event.searchText;

    if (this.popupOpenField == 'jobPlanNumber') {
      this.getJobPlanPopupData();
    } else if (this.popupOpenField == 'tccid') {
      this.getTccidPopupData();
    } else if (this.popupOpenField == 'craft') {
      this.leadCraftPopupData();
      // for part
    } else if (this.popupOpenField == 'item') {
      this.GetItemSearch();
    }
  }

  dataItemSelcted(dataItem: any) {

    //Labour
    if (['jobPlanNumber', 'tccid', 'craft'].includes(this.popupOpenField)) {

      let index = this.labourViewData.findIndex((x) => x.changeItemId == this.cSelectedRow.changeItemId);

      if (dataItem && this.popupOpenField != '' && index != -1) {


        if (this.popupOpenField == 'jobPlanNumber') {
          this.labourViewData[index].jobPlanDescription = dataItem?.jobPlanDescription || '';
          this.labourViewData[index].jobPlanNumber = String(dataItem?.jobPlanNumber).trim();
          this.onValueChange(this.labourViewData[index], 'jobPlanNumber', dataItem?.jobPlanNumber);

          // this.partsViewData.forEach((obj, pindex) => {

          //   if (obj.rowNumber === this.cSelectedRow.changeitemId) {
          //     this.partsViewData[pindex].jobPlanNumber = dataItem?.jobPlanNumber;
          //     this.onPartValueChange(this.partsViewData[pindex], 'jobPlanNumber', dataItem?.jobPlanNumber);
          //   }
          // });
          this.getPartsViewData();


        } else if (this.popupOpenField == 'tccid') {
          this.labourViewData[index].tccid = String(dataItem?.taskID).trim();
          this.onValueChange(this.labourViewData[index], 'tccid', dataItem?.taskID);
        }

        else if (this.popupOpenField == 'craft') {
          this.labourViewData[index].craft = dataItem?.code?.trim();
          this.onValueChange(this.labourViewData[index], 'craft', dataItem?.code?.trim());
        }
      }
    }
    //Part
    else if (['item'].includes(this.popupOpenField)) {

      let index = this.partsViewData.findIndex((x) => x.changeItemId == this.cSelectedRow.changeItemId);

      if (dataItem && this.popupOpenField != '' && index != -1) {
        if (this.popupOpenField == 'item') {
          this.partsViewData[index].item = String(dataItem?.itemNumber).trim();
          this.partsViewData[index].branchPlant = String(dataItem?.branch).trim();
          this.partsViewData[index].compBranchPlant = String(dataItem?.branch).trim();

          this.onPartValueChange(this.partsViewData[index], 'item', dataItem?.itemNumber);
          this.onPartValueChange(this.partsViewData[index], 'branchPlant', dataItem?.branch);
        }
      }

    }

    this.closeActionPopup(false);
  }

  clearAll() {
    if (!confirm("All Job Plan, not just selected, will be cleared from CR. Are you sure?"))
      return

    this.ClearJobPlanLabourNew(true, '');

  }
  clearSelected() {

    if (!confirm("All selected records but the ones already added to CR will be cleared. Are you sure?"))
      return

    let changeItemIds = this.labourViewData.filter(data => [...this.labourSelectedIds].includes(data.changeItemId)).map(data => data.changeItemId);
    let jobplanIds = this.labourViewData.filter(data => [...this.labourSelectedIds].includes(data.changeItemId && data.id > 0)).map(data => data.jobPlanNumber);

    //delete localy stored

    this.ClearJobPlanLabourNew(false, changeItemIds.join(','), jobplanIds.join(','));


  }

  view_tooltipList: any[] = [];
  @ViewChild(TooltipDirective) public tooltipDir!: TooltipDirective;

  showTooltip(event: MouseEvent) {
    const element = event.target as HTMLElement;
    this.view_tooltipList = [];
    if ((element.nodeName === "SPAN" && (element.className === "headerTagNumberSpan"))) {
      if (element.id.includes("equipTagNumberLabour_") && element.id.split("_").length > 1) {
        let index = parseInt(element.id.split("_")[1]);

        this.view_tooltipList = this.labourViewData[index].equipTagNumberList;
      } else if (element.id.includes("mwoNumberLabour_") && element.id.split("_").length > 1) {
        let index = parseInt(element.id.split("_")[1]);

        this.view_tooltipList = this.labourViewData[index].mwoList;
      } else if (element.id.includes("mwoProblemDescriptionLabour_") && element.id.split("_").length > 1) {
        let index = parseInt(element.id.split("_")[1]);

        this.view_tooltipList = this.labourViewData[index].mwoProbDescList;
      }
      if (this.view_tooltipList?.length > 5) {
        this.tooltipDir.toggle(element);
      }
    }
    else {
      this.tooltipDir.hide();
    }

  }

  showTooltipParts(event: MouseEvent) {
    const element = event.target as HTMLElement;
    this.view_tooltipList = [];
    if ((element.nodeName === "SPAN" && (element.className === "headerTagNumberSpan"))) {
      if (element.id.includes("equipTagNumberParts_") && element.id.split("_").length > 1) {
        let index = parseInt(element.id.split("_")[1]);
        this.view_tooltipList = this.filterPartsViewData[index].equipTagNumberList;
      } else if (element.id.includes("mwoNumberParts_") && element.id.split("_").length > 1) {
        let index = parseInt(element.id.split("_")[1]);
        this.view_tooltipList = this.filterPartsViewData[index].mwoList;
      } else if (element.id.includes("mwoProblemDescriptionParts_") && element.id.split("_").length > 1) {
        let index = parseInt(element.id.split("_")[1]);

        this.view_tooltipList = this.filterPartsViewData[index].mwoProbDescList;

      }
      if (this.view_tooltipList?.length > 5) {
        this.tooltipDir.toggle(element);
      }

    } else {
      this.tooltipDir.hide();
    }
  }





  AddToCrClicked: boolean = false;

  validateJPBuild() {

    let flagReceived = confirm("Are you sure?");
    if (flagReceived) {
      this.mwoErrorTextList = [];
      this.checkMwoNumberExists();
    }
  }


  checkValidations() {
    let errorMessagesLabour: string = '';
    let errorMessagesParts: string = '';

    this.partsViewData.forEach((part: any, index: number) => {
      this.partsViewData[index].errorList = [];
      if (Number(part.quantity || 0) <= 0) {
        this.partsViewData[index].errorMessagesList.push(`Quantity (greater than zero)`);
        this.partsViewData[index].errorList.push('quantity');
      }

      this.partsViewData[index].errorMessage = this.partsViewData[index].errorList.length ? this.partsViewData[index].errorMessagesList.join(' | ') : '';

      errorMessagesParts += this.partsViewData[index].errorList.length ? `Row ${index + 1} ` + this.partsViewData[index].errorMessage + '<br/>' : '';

    });

    this.labourViewData.forEach((labour: any, index: number) => {
      this.labourViewData[index].errorList = [];
      this.labourViewData[index].errorMessagesList = [];

      // if (labour.acdAction) { }
      // if (labour.acdActionLabel) { }
      // if (labour.be_changeItemId) { }
      // if (labour.branchPlant) { }
      // if (labour.changeItemId) { }
      // if (labour.changeitemId) { }
      // if (labour.craft) { }
      // if (labour.crewSize) { }
      // if(labour.description) { } 
      if (labour.description.trim() === "" || labour.description.trim().length > 30) {
        this.labourViewData[index].errorMessagesList.push(`Description (not blank, max 30 characters)`);
        this.labourViewData[index].errorList.push('description');
      }
      // if(labour.duration) { } 
      if (labour.duration < 0) {
        this.labourViewData[index].errorMessagesList.push(`duration cannot be negative`);
        this.labourViewData[index].errorList.push('duration');

      }
      // if (labour.emdmKey) { }
      // if (labour.equipTagNumber) { }
      // if (labour.equipmentNumber) { }
      // if(labour.fileDescription) { } 
      if (labour.fileDescription?.trim().length > 148) {
        this.labourViewData[index].errorMessagesList.push(`File Description (max 148 characters)`);
        this.labourViewData[index].errorList.push('fileDescription');
      }
      // if(labour.fileName) { } 
      if (labour.fileName?.trim().length > 50) {
        this.labourViewData[index].errorMessagesList.push(`MWI/File Name (max 50 characters)`);
        this.labourViewData[index].errorList.push('fileName');
      }
      // if (labour.icyn) { }
      // if (labour.inspectionID) { }
      // if (labour.isStaging) { }
      // if(labour.jobPackNo) { } 
      if (labour.jobPackNo?.trim().length > 15) {
        this.labourViewData[index].errorMessagesList.push(`Job Pack Number exceeds allowed limit`);
        this.labourViewData[index].errorList.push('jobPackNo');
      }
      // if(labour.jobPlanDescription) { } 
      if (labour.jobPlanDescription?.trim().length > 30) {
        this.labourViewData[index].errorMessagesList.push(`Length of Job Plan Description exceeds 30 characters`);
        this.labourViewData[index].errorList.push('jobPlanDescription');
      }
      // if (labour.jobPlanNumber) { }
      // if (labour.modifiedFields) { }
      // if (labour.mwoNumber) { }
      // if (labour.mwoProblemDescription) { }
      // if (labour.norms) { }
      // if(labour.opsSeq) { } 
      if (Number(labour.opsSeq || 0) % 10 !== 0) {
        this.labourViewData[index].errorMessagesList.push(`Operation Sequence should be in increment of 10`);
        this.labourViewData[index].errorList.push('opsSeq');
      }
      // if(labour.percentageOverlap) { } 
      if (Number(labour.percentageOverlap) < 0 || Number(labour.percentageOverlap) > 100) {
        this.labourViewData[index].errorMessagesList.push(`Percentage Overlap (0-100 only)`);
        this.labourViewData[index].errorList.push('percentageOverlap');
      }
      // if (labour.performanceStandard) { }
      // if(labour.tccid) { } 
      if (labour.tccid?.trim() === "") {
        this.labourViewData[index].errorMessagesList.push(`Should TCC ID be populated?`);
        this.labourViewData[index].errorList.push('tccid');
      }
      // if(labour.textAttachments) { } 
      if (labour.textAttachments?.trim().length > 1500) {
        this.labourViewData[index].errorMessagesList.push(`Text Attachment (max 1500 characters)`);
        this.labourViewData[index].errorList.push('textAttachments');
      }
      // if(labour.url) { }  
      if (labour.url?.trim().length > 254) {
        this.labourViewData[index].errorMessagesList.push(`URL (max 254 characters)`);
        this.labourViewData[index].errorList.push('url');
      }

      if (labour.jbcd?.trim() !== "1" && labour.jbcd?.trim() !== "") {
        // this.labourViewData[index].errorMessagesList.push(`Invalid Value in JBCD field`);
        // this.labourViewData[index].errorList.push('jbcd');
      }

      this.labourViewData[index].errorMessage = this.labourViewData[index].errorList.length ? this.labourViewData[index].errorMessagesList.join(' | ') : '';

      errorMessagesLabour += this.labourViewData[index].errorList.length ? `Row ${index + 1} ` + this.labourViewData[index].errorMessage + '<br/>' : '';

    });

    return { errorMessagesLabour, errorMessagesParts };
  }

  save() {

    let jobPlanLabours: JobPlanLabour[] = this.labourViewData.map<JobPlanLabour>(data => {
      let operationId = 4 // no change
      if (data.changeItemId < 0) {
        data.operationId = 1 // Add
      } else if ((data.fieldChangedListTrack?.length)) {
        data.operationId = 3 // change 
      }
      return {
        "acdAction": this.action.findIndex((ac: String) => ac == data.acdAction),
        "acdActionLabel": data.acdActionLabel,
        "mwoNumber": data.mwoNumber || null,
        "mwoProblemDescription": data.mwoProblemDescription,
        "equipTagNumber": data.equipTagNumber || null,
        "jobPlanNumber": data.jobPlanNumber,
        "jobPlanDescription": data.jobPlanDescription,
        "branchPlant": data.branchPlant,
        "performanceStandard": data.performanceStandard,
        "craft": data.craft,
        "opsSeq": data.opsSeq ?? 0,
        "norms": data.norms,
        "description": data.description,
        "duration": data.duration ?? 0,
        "crewSize": data.crewSize ?? 0,
        "icyn": data.icyn,
        "percentageOverlap": data.percentageOverlap ?? 0,
        "tccid": data.tccid,
        "inspectionID": data.inspectionID,
        "equipmentNumber": data.equipmentNumber, // "errorMessage": "ROW 1:- Invalid Value in Equipment Number field; ; ",
        "jobPackNo": data.jobPackNo,
        "fileName": data.fileName ?? '',
        "url": data.url,
        "fileDescription": data.fileDescription,
        "textAttachments": data.textAttachments,
        "emdmKey": data.emdmKey,
        "modifiedFields": data.fieldChangedList?.length ? data.fieldChangedList?.join(';') : null,
        "isStaging": data.isStaging,
        "changeItemId": data.changeItemId,//
        "id": data.id,
        "rowNumber": data.rowNumber,//
        "genericKeyText": data.genericKeyText,
        "mediaObjectSequence": data.mediaObjectSequence,
        "mediaObjectType": data.mediaObjectType,
        "unitOfMeasure": data.unitOfMeasure,
        "isNewJobPlan": data.isNewJobPlan,
        "messageNumber": data.messageNumber,
        "jbcd": data.jbcd,
        "isCopy": data.isCopy,
        "isCreateNew": data.isCreateNew,
        "originalJobPlanNumber": data.originalJobPlanNumber,
        "operationId": data.operationId
      }
    });

    let jobPlanParts: JobPlanPart[] = this.partsViewData.map<JobPlanPart>(data => {
      // let operationId = 4 // no change
      if (data.changeItemId < 0) {
        data.operationId = 1 // Add
      } else if (data.fieldChangedListTrack?.length) {
        data.operationId = 3 // change 
      }
      return {
        "acdAction": this.action.findIndex((ac: String) => ac == data.acdAction),
        "equipTagNumber": data.equipTagNumber, // equipmentNumber
        "mwoNumber": data.mwoNumber || null,
        "mwoProblemDescription": data.mwoProblemDescription,
        "jobPlanNumber": data.jobPlanNumber,
        "branchPlant": data.branchPlant || null,
        "item": Number(data.item),
        "quantity": data.quantity ?? 0,
        "compBranchPlant": data.compBranchPlant || data.branchPlant || null,
        "operationSequence": data.operationSequence ?? 0,
        "emdmKey": data.emdmKey,
        "modifiedFields": data.fieldChangedList?.length ? data.fieldChangedList.join(';') : null,
        "isStaging": data.isStaging,
        "changeItemId": data.changeItemId, //
        "id": data.id,
        "lineNumber": data.lineNumber,
        "unitOfMeasure": data.unitOfMeasure,
        "isNewJobPlan": data.isNewJobPlan,
        "isTemplate": data.isTemplate,
        "isCreateNew": data.isCreateNew,
        "rowNumber": data.rowNumber,
        "isCopy": data.isCopy,
        "originalJobPlanNumber": data.originalJobPlanNumber,
        "operationId": data.operationId,

      }
    });

    let deleteLabourView = this.localDeleteLabourData.map((data: any) => {
      // data.acdAction = this.action.findIndex((ac: String) => ac == data.acdAction);
      // data.operationId = 2;
      return {
        "acdAction": this.action.findIndex((ac: String) => ac == data.data.acdAction),
        "acdActionLabel": data.data.acdActionLabel,
        "mwoNumber": data.data.mwoNumber || null,
        "mwoProblemDescription": data.data.mwoProblemDescription,
        "equipTagNumber": data.data.equipTagNumber || null,
        "jobPlanNumber": data.data.jobPlanNumber,
        "jobPlanDescription": data.data.jobPlanDescription,
        "branchPlant": data.data.branchPlant,
        "performanceStandard": data.data.performanceStandard,
        "craft": data.data.craft,
        "opsSeq": data.data.opsSeq ?? 0,
        "norms": data.data.norms,
        "description": data.data.description,
        "duration": data.data.duration ?? 0,
        "crewSize": data.data.crewSize ?? 0,
        "icyn": data.data.icyn,
        "percentageOverlap": data.data.percentageOverlap ?? 0,
        "tccid": data.data.tccid,
        "inspectionID": data.data.inspectionID,
        "equipmentNumber": data.data.equipmentNumber, // "errorMessage": "ROW 1:- Invalid Value in Equipment Number field; ; ",
        "jobPackNo": data.data.jobPackNo,
        "fileName": data.data.fileName,
        "url": data.data.url,
        "fileDescription": data.data.fileDescription,
        "textAttachments": data.data.textAttachments,
        "emdmKey": data.data.emdmKey,
        "modifiedFields": data.data.modifiedFields,
        "isStaging": data.data.isStaging,
        "changeItemId": data.data.changeItemId > 0 ? data.data.changeItemId : 0,//
        "id": data.data.id,
        "rowNumber": data.data.rowNumber,//
        "genericKeyText": data.data.genericKeyText,
        "mediaObjectSequence": data.data.mediaObjectSequence,
        "mediaObjectType": data.data.mediaObjectType,
        "unitOfMeasure": data.data.unitOfMeasure,
        "isNewJobPlan": data.data.isNewJobPlan,
        "messageNumber": data.data.messageNumber,
        "jbcd": data.data.jbcd,
        "isCopy": data.data.isCopy,
        "isCreateNew": data.data.isCreateNew,
        "originalJobPlanNumber": data.data.originalJobPlanNumber,
        operationId: 2
      };
    })
    let deletePartsView = this.deletePartsViewData.map((data: any) => {
      // data.acdAction = this.action.findIndex((ac: String) => ac == data.acdAction);
      // data.operationId = 2;
      return {
        "acdAction": this.action.findIndex((ac: String) => ac == data.acdAction),
        "equipTagNumber": data.equipTagNumber, // equipmentNumber
        "mwoNumber": data.mwoNumber || null,
        "mwoProblemDescription": data.mwoProblemDescription,
        "jobPlanNumber": data.jobPlanNumber,
        "branchPlant": data.branchPlant || null,
        "item": Number(data.item),
        "quantity": data.quantity ?? 0,
        "compBranchPlant": data.compBranchPlant || null,
        "operationSequence": data.operationSequence ?? 0,
        "emdmKey": data.emdmKey,
        "modifiedFields": data.modifiedFields,
        "isStaging": data.isStaging,
        "changeItemId": data.changeItemId > 0 ? data.changeItemId : 0, //
        "id": data.id,
        "lineNumber": data.lineNumber,
        "unitOfMeasure": data.unitOfMeasure,
        "isNewJobPlan": data.isNewJobPlan,
        "isTemplate": data.isTemplate,
        "isCreateNew": data.isCreateNew,
        "rowNumber": data.rowNumber,
        "isCopy": data.isCopy,
        "originalJobPlanNumber": data.originalJobPlanNumber,
        operationId: 2
      };
    });

    let body = {
      "changeRequestId": this.crNo,
      "jobPlanLabours": [...jobPlanLabours, ...deleteLabourView],
      "jobPlanParts": [...jobPlanParts, ...deletePartsView]
    }
    this.ValidateAndSaveToCr(body).then((data: any) => {
      if (data?.validationResults?.length) {
        let lErrorCode: any = {
          C: 'craft',//
          JPN: 'jobPlanNumber',//
          JPND: 'jobPlanDescription',//
          TCC: 'tccid',//'taskId',
          OS: 'opsSeq',//
          D: 'description',//
          DU: 'duration',//
          CS: 'crewSize',//
          PO: 'percentageOverlap',//
          FN: 'fileName',//
          URL: 'url',//
          FD: 'fileDescription',//
          TA: 'textAttachments',//
          TYCD: 'jbcd',
          URRF: 'jobPackNo',//'jobPackNumber',
          // TCC:'taskId',
          EQNM: 'equipmentNumber',//
          ICYN: 'icyn',//
        }
        let pErrorCode: any = {
          IN: 'item',//'itemNumber',
          OPSQ: 'operationSequence',
          Q: 'quantity',
          CBP: 'compBranchPlant',//'branchCode',
        }

        /**
         *  [
        {
            "errorMessage": "ROW 1|Craft; Task Consequence Code; Operation Sequence cannot be zero or empty; Description (not blank, max 30 characters); Crew Size",
            "warningMessage": "ROW 1|Should TCC ID be populated?",
            "fieldList": "C;TCC;OS;D;CS;TCC",
            "rowNumber": 1
        },
        {
            "errorMessage": "ROW 1|Branch/Plant is different between the Job Plan and the Item selected in the Parts section; ITEM; Quantity (greater than zero); Invalid CompBranch/Plant",
            "warningMessage": "",
            "fieldList": "IN;IN;Q;CBP",
            "rowNumber": 1
        }
    ]
         */
        for (let i = 0; i < data?.validationResults?.length; i++) {
          const row = data?.validationResults[i];
          let errList = row.fieldList.split(';');
          if (row.rowNumber) {
            if (errList.length > 0) {
              if (lErrorCode[errList[0]]) {
                // lErrorList[row.rowNumber] = errList.map((row: string) => lErrorCode[row]);
                this.labourViewData[row.rowNumber - 1].errorList = errList.map((row: string) => lErrorCode[row]);
                this.labourViewData[row.rowNumber - 1].errorList1 = (errList.map((row: string) => lErrorCode[row])).length;
              } else if (pErrorCode[errList[0]] && this.partsViewData.length >= row.rowNumber) {
                // pErrorList[row.rowNumber] = errList.map((row: string) => pErrorCode[row]);
                this.partsViewData[row.rowNumber - 1].errorList = errList.map((row: string) => pErrorCode[row]);
                this.partsViewData[row.rowNumber - 1].errorList1 = (errList.map((row: string) => pErrorCode[row])).length;
              }
            }
          }
        }
        this.labourSelectedIds.clear();
        this.partsSelectedIds.clear();
        this.labourViewData = [...this.labourViewData]
        this.partsViewData = [...this.partsViewData]
        this.getPartsViewData();

        // this.labourViewData = this.labourViewData.map((data:any, index:number)=>{
        //   if(lErrorList[index])
        //     data.errorList = lErrorList[index];
        //   return data;
        // })
        // this.partsViewData = this.partsViewData.map((data:any, index:number)=>{
        //   if(pErrorList[index])
        //     data.errorList = pErrorList[index]; 
        //   return data;
        // })

        let lErrorCount = 0;
        let lWarningCount = 0;

        let errMess = data?.validationResults.reduce((pre: any, next: any) => {
          if (next.errorMessage) {
            lErrorCount++
            let formattedError = next.errorMessage.replace(/\s*;\s*/g, ',<br/>');
            pre = pre + formattedError + '<br/>'
          }
          return pre
        }, '')
        let warningMessage = data?.validationResults.reduce((pre: any, next: any) => {
          if (next.warningMessage) {
            lWarningCount++
            let formattedError = next.warningMessage.replace(/\s*;\s*/g, ',<br/>');
            pre = pre + formattedError + '<br/>';
          }
          return pre
        }, '')

        if (errMess) {
          // errMess = `There are ${lErrorCount} error(s): <br />` + errMess
          errMess = `Please fix highlighted fields:<br />` + errMess
          this.commonService.showNotificationMessage(errMess, 'error', 'center');
        } else {
          // warningMessage = warningMessage;
          this.stepNavigateTo.emit("Summary");
          this.commonService.showNotificationMessage(warningMessage, 'warning', 'center', 200, false);
        }
      }
      else {
        this.commonService.showNotificationMessage(data.status, 'success', 'center', 200, false);
        this.stepNavigateTo.emit("Summary");
      }

    })
  }

  checkMwoNumberExists() {
    let validateMWOExist = false;
    if ("shouldValidateMWOExist" in sessionStorage) {
      validateMWOExist = sessionStorage.getItem("shouldValidateMWOExist")?.toLocaleLowerCase() === "true";
    }
    if (validateMWOExist) {
       let mwoList = this.partsViewData
      ?.filter((data: any) => data?.mwoNumber) // Filter out null/undefined mwoNumber first
      ?.flatMap((data: any) => data.mwoNumber.split(',')?.map((mwo: string) => mwo?.trim()))
      ?.filter((mwo: string) => mwo !== null && mwo !== undefined && mwo.trim() !== "" && mwo.trim().length > 0)
      ?.filter((mwo: string) => !mwo.toUpperCase().includes('MCTMWO')); // Exclude MWOs containing MCTMWO;
      // Remove duplicates using Set
      mwoList = mwoList ? [...new Set(mwoList)] : [];
      if (mwoList && mwoList.length > 0) {
        this.pmService.checkMwoNumberExists(this.crNo, mwoList).subscribe({
          next: (response: any) => {
            if (response.length > 0) {
              this.mwoErrorTextList = response;
            } else {
              this.save();
            }
          },
          error: (err) => {
          }
        });
      } else {
        this.save();
      }
    } else {
      this.save();
    }
  }

  onEnterItemPressed(dataItem: any) {
    if (dataItem.branchPlant && dataItem.item != "") {
      this.jobPlanService.GetOnChangeItemSearch(dataItem.branchPlant, dataItem.item).subscribe({
        next: (response: any) => {
          if (response) {
            dataItem.compBranchPlant = "  "+ response.branchPlant
          }
        },
        error: () => {

        }
      });
    }    
  }
}
